'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _Vas = require('../Vas');

var _Vas2 = _interopRequireDefault(_Vas);

require('../css/TariffingProductsToPoints.css');

var _Textfield = require('./Textfield');

var _Textfield2 = _interopRequireDefault(_Textfield);

var _SelectField = require('./SelectField');

var _SelectField2 = _interopRequireDefault(_SelectField);

var _AutocompleteField = require('./AutocompleteField');

var _AutocompleteField2 = _interopRequireDefault(_AutocompleteField);

var _ExtendedButton = require('./ExtendedButton');

var _ExtendedButton2 = _interopRequireDefault(_ExtendedButton);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Loading = require('./Loading');

var _Loading2 = _interopRequireDefault(_Loading);

var _MessageBox = require('./MessageBox');

var _MessageBox2 = _interopRequireDefault(_MessageBox);

var _DateField = require('./DateField');

var _DateField2 = _interopRequireDefault(_DateField);

var _modelsLib = require('models-lib');

var _utilsLib = require('utils-lib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var moment = require('moment');
moment().format();

var TariffingProductsToPoints = function (_Component) {
    _inherits(TariffingProductsToPoints, _Component);

    //#region Komponente
    function TariffingProductsToPoints(props) {
        _classCallCheck(this, TariffingProductsToPoints);

        var _this = _possibleConstructorReturn(this, (TariffingProductsToPoints.__proto__ || Object.getPrototypeOf(TariffingProductsToPoints)).call(this, props));

        _this.state = {};
        _this.state.me = _this;

        _this.ContractId = _this.props.ContractId ? _this.props.ContractId : "00000";

        _this.CustomerId = _this.props.CustomerId ? _this.props.CustomerId : "00000";

        _this.TariffPointSearchlegth = _this.props.TariffPointSearchlegth ? _this.props.TariffPointSearchlegth : 3;

        _this.FilteredProductIdents = _this.props.FilteredProductIdents ? _this.props.FilteredProductIdents.split(';') : [];

        //TimeOut Zeit für TariffPoints - Requests
        _this.TimeOutTime = _this.props.TimeOutTime ? _this.props.TimeOutTime : 1000;

        //soll das AboCenter angezeigt werden
        _this.ShowClientsBox = _this.props.ShowClientsBox !== null && _this.props.ShowClientsBox !== undefined ? _this.props.ShowClientsBox : true;
        //soll das Vertragsendedatum angezeigt werden
        _this.ShowContractEnd = _this.props.ShowContractEnd !== null && _this.props.ShowContractEnd !== undefined ? _this.props.ShowContractEnd : true;
        //wie viele Monate in der Zukunft sollen die Vertragsbeginndaten anfangen
        _this.ContractStartMonthsInFuture = _this.props.ContractStartMonthsInFuture !== null && _this.props.ContractStartMonthsInFuture !== undefined ? _this.props.ContractStartMonthsInFuture : 0;

        _this.MethodAfterProducts = _this.props.MethodAfterProducts ? _this.props.MethodAfterProducts : null;

        _this.MethodAfterTickets = _this.props.MethodAfterTickets ? _this.props.MethodAfterTickets : null;

        _this.SubstringsAllowed = _this.props.SubstringsAllowed !== null && _this.props.SubstringsAllowed !== undefined ? _this.props.SubstringsAllowed : false;
        _this.FindStrFromStreets = _this.props.FindStrFromStreets !== null && _this.props.FindStrFromStreets !== undefined ? _this.props.FindStrFromStreets : false;

        //Hinweistext
        _this.Text = _this.props.Text ? _this.props.Text : "";

        _this.ContractEndText = _this.props.ContractEndText ? _this.props.ContractEndText : _Vas2.default.getText("Labels", "ContractEnd");

        _this.NotTicketText = _this.props.NotTicketText ? _this.props.NotTicketText : _Vas2.default.getText("Labels", "TicketNotInsertet");

        _this.ProductFirstText = _this.props.ProductFirstText ? _this.props.ProductFirstText : _Vas2.default.getText("Labels", "TariffProductFirst");

        _this.ApplicationUrl = _this.props.ApplicationUrl;
        _this.ApiKey = _this.props.ApiKey;
        _this.ApiUrl = _this.props.ApiUrl;

        _this.contractStartInput = _react2.default.createRef();
        _this.clientInput = _react2.default.createRef();
        _this.priceInput = _react2.default.createRef();
        _this.fromInput = _react2.default.createRef();
        _this.toInput = _react2.default.createRef();
        _this.viaInput = _react2.default.createRef();
        _this.tariffProductInput = _react2.default.createRef();
        _this.fromToViaInput = _react2.default.createRef();
        _this.contractEndInput = _react2.default.createRef();
        _this.customerAboveInput = _react2.default.createRef();

        // eslint-disable-next-line no-unused-expressions
        _this.Request = new _modelsLib.RequestAjaxClass(function (error) {
            _this.props.ErrorHandling ? _this.props.ErrorHandling(error) : '';
        }, null);
        // eslint-disable-next-line no-unused-expressions
        _this.Request2 = new _modelsLib.RequestAjaxClass(function (error) {
            _this.props.ErrorHandling ? _this.props.ErrorHandling(error) : '';
        }, null);
        // eslint-disable-next-line no-unused-expressions
        _this.Request3 = new _modelsLib.RequestAjaxClass(function (error) {
            _this.props.ErrorHandling ? _this.props.ErrorHandling(error) : '';
        }, null);
        // eslint-disable-next-line no-unused-expressions
        _this.Request4 = new _modelsLib.RequestAjaxClass(function (error) {
            _this.props.ErrorHandling ? _this.props.ErrorHandling(error) : '';
        }, null);
        // eslint-disable-next-line no-unused-expressions
        _this.Request5 = new _modelsLib.RequestAjaxClass(function (error) {
            _this.props.ErrorHandling ? _this.props.ErrorHandling(error) : '';
        }, null);

        _this.ContractStartParamsModel = new _modelsLib.ContractStartParamsModel([_this], null, _this.Request3);
        _this.ClientModel = new _modelsLib.ClientModel([_this], null, _this.Request2);
        _this.CustomerClientModel = new _modelsLib.ClientModel([_this], null, _this.Request2);

        _this.CustomerModel = new _modelsLib.CustomerModel([_this], null, _this.Request5);

        _this.TariffProductsModel = new _modelsLib.TariffProductsModel([_this], null, _this.Request);
        _this.ProductModel = new _modelsLib.TariffProductsModel([_this], null, _this.Request);

        _this.TariffPointsModelFrom = new _modelsLib.TariffPointsModel([_this], "TariffPointFrom", _this.Request);
        _this.TariffPointsModelTo = new _modelsLib.TariffPointsModel([_this], "TariffPointTo", _this.Request2);

        _this.AccountsModel = new _modelsLib.AccountsModel([_this]);

        _this.MultimediaTextModel = new _modelsLib.MultimediaTextModel([_this], null, _this.Request);

        _this.MultimediaTextProductModel = new _modelsLib.MultimediaTextModel([_this], "MultimediaTextProduct", _this.Request4);

        _this.AboCenterArray = [];
        _this.TariffProducts = [];

        localStorage.setItem('IsCouponCode', false);

        _this.allFilled = _this.required === true ? false : true;

        _this.first = null;

        _this.Tariff = localStorage.getItem('Tariff') !== null && localStorage.getItem('Tariff') !== undefined ? JSON.parse(localStorage.getItem('Tariff')) : null;

        _this.hint = _react2.default.createElement('tr', null);

        _this.ConfigDefaults = _this.props.ConfigDefaults;
        _this.ConfigContractEnd = _this.props.ConfigContractEnd;
        _this.DefaultSchueler = _this.ConfigDefaults.DefaultSchuelerticket ? _this.ConfigDefaults.DefaultSchuelerticket : false;
        _this.DefaultSonst = _this.ConfigDefaults.DefaultSonst ? _this.ConfigDefaults.DefaultSonst : false;

        _this.state.ShowDateField = false;
        _this.state.SetDefault = _this.DefaultSchueler === true || _this.DefaultSonst === true ? true : false;

        _this.state.ShowDouble = _this.props.ShowDouble ? _this.props.ShowDouble : false;

        _this.state.ShowPriceLevel = _this.props.ShowPriceLevel ? _this.props.ShowPriceLevel : false;

        _this.state.ShowTariffPointIdent = _this.props.ShowTariffPointIdent ? _this.props.ShowTariffPointIdent : false;

        _this.role = localStorage.getItem("vas_role") ? localStorage.getItem("vas_role") : "1";

        _this.deleteRelationTo = _this.props.DeleteRelationTo == null || _this.props.DeleteRelationTo == undefined ? true : _this.props.DeleteRelationTo;

        return _this;
    }

    _createClass(TariffingProductsToPoints, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.state.ShowTariffPointIdent) {
                this.ConfigDefaults.DefaultSonstFromValue = this.ConfigDefaults.DefaultSonstFromValue + " " + this.ConfigDefaults.DefaultSonstFromIdent;
                this.ConfigDefaults.DefaultSonstToValue = this.ConfigDefaults.DefaultSonstToValue + " " + this.ConfigDefaults.DefaultSonstToIdent;
            }

            localStorage.removeItem('ContractOverviewCustomerBirthdate');
            localStorage.removeItem('ContractOverviewCustomer');
            localStorage.removeItem('ContractOverviewCustomerPayment');
            localStorage.removeItem('ContractOverviewTariffPointFrom');
            localStorage.removeItem('ContractOverviewTariffPointTo');
            localStorage.removeItem('ContractOverviewTariffProduct');
            localStorage.removeItem('ContractOverviewContractStart');
            localStorage.removeItem('ContractOverviewContractEnd');
            localStorage.removeItem('AccountOwner');
            localStorage.removeItem('AccountOwnerBirthDate');
            localStorage.removeItem('LegalGuardian');
            localStorage.removeItem('LegalGuardianBirthDate');

            localStorage.removeItem('MultimediaTextProduct');

            localStorage.removeItem('ContractOverviewTariffPointFromAtg');
            localStorage.removeItem('ContractOverviewTariffPointToAtg');

            this.setVisible("Product");

            this.Request.setAuth(false);
            this.Request.setApiKey(this.ApiKey);
            this.Request.setApiUrl(this.ApiUrl);
            this.Request.setErrorHandler(function () {
                (0, _jquery2.default)("#LoadingIconPopUp").removeClass().addClass('hide');
            });

            this.Request2.setAuth(false);
            this.Request2.setApiKey(this.ApiKey);
            this.Request2.setApiUrl(this.ApiUrl);
            this.Request2.setErrorHandler(function () {
                (0, _jquery2.default)("#LoadingIconPopUp").removeClass().addClass('hide');
            });

            this.Request3.setAuth(false);
            this.Request3.setApiKey(this.ApiKey);
            this.Request3.setApiUrl(this.ApiUrl);
            this.Request3.setErrorHandler(function () {
                (0, _jquery2.default)("#LoadingIconPopUp").removeClass().addClass('hide');
            });

            this.Request4.setAuth(false);
            this.Request4.setApiKey(this.ApiKey);
            this.Request4.setApiUrl(this.ApiUrl);
            this.Request4.setErrorHandler(function () {
                (0, _jquery2.default)("#LoadingIconPopUp").removeClass().addClass('hide');
                localStorage.removeItem('MultimediaTextProduct');
            });

            this.Request5.setAuth(false);
            this.Request5.setApiKey(this.ApiKey);
            this.Request5.setApiUrl(this.ApiUrl);
            this.Request5.setErrorHandler(function () {
                (0, _jquery2.default)("#LoadingIconPopUp").removeClass().addClass('hide');
            });

            //this.ContractStartParamsModel.GetContractStartParamsByTicketId();


            if (this.role === "1") {
                this.ClientModel.GetClients();
                //this.GetTickets();
            }

            var selectFields = [{ Key: this.contractStartInput.current, Index: 1, Step: 1 }, { Key: this.tariffProductInput.current, Index: 3, Step: 1 }, { Key: this.viaInput.current, Index: 6, Step: 1 }];

            var selectFieldsFixedRoute = [{ Key: this.contractStartInput.current, Index: 1, Step: 1 }, { Key: this.tariffProductInput.current, Index: 3, Step: 1 }, { Key: this.viaInput.current, Index: 6, Step: 1 }];

            if (this.ShowClientsBox === true) {
                selectFields.push({ Key: this.clientInput.current, Index: 2, Step: 1 });

                selectFieldsFixedRoute.push({ Key: this.clientInput.current, Index: 2, Step: 1 });
            }

            var textFields = [{ Key: this.fromInput.current, Index: 4, Step: 1 }, { Key: this.toInput.current, Index: 5, Step: 1 }];

            var contractEnd = [];
            if (this.ShowContractEnd === true) {
                //if(this.ConfigContractEnd.ChangeContractEnd === true){
                //contractEnd.push({Key:this.contractEndInput.current,Index:7,Step:1});
                //}
            }

            this.setState({ requiredFields: textFields,
                requiredSelectField: selectFields,
                selectFieldsFixedRoute: selectFieldsFixedRoute,
                contractEndField: contractEnd }, function () {

                _utilsLib.SetRequired.Set(_this2.state.requiredFields, _this2.state.requiredSelectField);
            });

            var me = this;
            document.addEventListener("keydown", function (event) {
                if (me.TimeOutTime) {
                    window.clearTimeout(me.TimeOutTime);
                }
            });

            if (this.role === "3") {
                if (this.CustomerId !== "00000") {
                    this.CustomerModel.GetCustomersAboveByCustomerId(localStorage.getItem("vas_customerId"), moment().format("YYYY-MM-DD T 00:00:00"), true);
                } else {
                    this.CustomerModel.GetCustomersAboveByCustomerId(localStorage.getItem("vas_customerId"), moment().format("YYYY-MM-DD T 00:00:00"), true);
                }
            }

            this.FontSizeClick();
            this.LogoClick();
        }
    }, {
        key: 'Update',
        value: function Update(observer) {
            var _this3 = this;

            var me = this;
            this.setState({}, function () {
                if (observer === "ContractStartParamsByTicketId" || observer === "GetContractStartParamsByContractId") {

                    var dateArr = [];
                    for (var i = 0; i < me.ContractStartParamsModel.ContractStarts.length; i++) {
                        var format = "DD.MM.YYYY";

                        if (localStorage.getItem('vas_language') === "en") {
                            format = "MM/DD/YYYY";
                        }

                        var date = _utilsLib.DateTimeHelper.StringToDate(me.ContractStartParamsModel.ContractStarts[i], true, localStorage.getItem('vas_language')).format(format);
                        dateArr.push({ Key: date, Display: date });
                    }
                    if (me.contractStartInput) {
                        if (me.contractStartInput.current) {
                            me.contractStartInput.current.setState({ Data: dateArr }, function () {
                                me.setTariff("ContractStart", dateArr);
                            });
                        }
                    }

                    if (localStorage.getItem('ChangeProductsFromTermsOfUsage') == 'true') {

                        me.changeProductFromTermsOfUsage((0, _jquery2.default)("#TariffProducts").val());

                        localStorage.removeItem('ChangeProductsFromTermsOfUsage');
                    }
                }
                if (observer === "Clients") {
                    var aboCenterArr = [];
                    if (me.ClientModel.Clients.length > 0) {
                        me.ClientModel.Clients.forEach(function (value) {
                            aboCenterArr.push({ Key: value.Id, Display: value.Description });
                        });
                        for (var _i = 0; _i < aboCenterArr.length; _i++) {
                            _this3.AboCenterArray.push({ Key: aboCenterArr[_i].Key, Display: aboCenterArr[_i].Display });
                        }

                        if (_this3.Tariff !== null && _this3.Tariff !== undefined) {
                            _this3.setTariff("Clients", aboCenterArr);
                        } else {
                            if (_this3.ShowClientsBox === false) {
                                _this3.setState({ AboCenter: aboCenterArr[0].Key }, function () {
                                    _this3.GetTickets();
                                });
                                //->>weiter bei Update(observer):Tickets
                            }
                        }
                    } else {
                        me.tariffProductInput.current.setState({ Loading: false });
                    }
                }
                if (observer === "Client") {
                    var idx = 0;
                    for (var _i2 = 0; _i2 < me.AboCenterArray.length; _i2++) {
                        if (me.AboCenterArray[_i2].Display === me.CustomerClientModel.Description) {
                            idx = _i2 + 1;
                        }
                    }

                    document.getElementById('AboCenter').selectedIndex = idx;

                    me.setState({ AboCenter: me.AboCenterArray[idx - 1].Key });
                }
                if (observer === "Tickets" || observer === "TicketsCustomerAbove") {
                    var data = me.TariffProductsModel.ProductList;
                    var tariffProductsArr = [];
                    var tariffProductsNoDuplicateArr = [];
                    var multiUserCountAdult = 0;
                    var multiUserCountChild = 0;

                    if (data !== null && data !== undefined) {
                        for (var _i3 = 0; _i3 < data.length; _i3++) {

                            //Bei MultiUserCount..  = NULL, dann 0
                            if (data[_i3].MultiUserCountAdult !== null) {
                                if (data[_i3].MultiUserCountAdult > 0) {
                                    multiUserCountAdult = data[_i3].MultiUserCountAdult - 1;
                                } else {
                                    multiUserCountAdult = data[_i3].MultiUserCountAdult;
                                }
                            }

                            if (data[_i3].MultiUserCountChild !== null) {
                                multiUserCountChild = data[_i3].MultiUserCountChild;
                            }

                            var tariffProduct = { Key: data[_i3].IdTicket + ";" + data[_i3].FlagMultiUser + ";" + data[_i3].FixedRoute + ";" + multiUserCountAdult + ";" + multiUserCountChild + ";" + data[_i3].Share1 + ";" + data[_i3].Share2 + ";" + data[_i3].FlagSchuelerAbo + ";" + data[_i3].PriceLevel,
                                Display: data[_i3].TicketName };

                            var productFiltered = false;

                            for (var j = 0; j < _this3.FilteredProductIdents.length; j++) {
                                if (data[_i3].TicketIdent === "01-991-02") {
                                    localStorage.setItem("Motiv1", JSON.stringify([data[_i3], null, null]));
                                    tariffProduct.Display = "Deutschlandticket Chipkarte";
                                    break;
                                }if (data[_i3].TicketIdent === _this3.FilteredProductIdents[j]) {
                                    if (data[_i3].TicketIdent === "01-992-02") {
                                        localStorage.setItem("Motiv2", JSON.stringify([data[_i3], null, null]));
                                    } else if (data[_i3].TicketIdent === "01-993-02") {
                                        localStorage.setItem("Motiv3", JSON.stringify([data[_i3], null, null]));
                                    }
                                    productFiltered = true;
                                    break;
                                }
                            }

                            if (!productFiltered) {

                                if (_this3.state.ShowDouble === false) {

                                    var isInserted = false;
                                    for (var _j = 0; _j < tariffProductsNoDuplicateArr.length; _j++) {
                                        if (tariffProductsNoDuplicateArr[_j].Display === tariffProduct.Display) {
                                            isInserted = true;
                                            break;
                                        }
                                    }
                                    if (isInserted === false) {
                                        tariffProductsNoDuplicateArr.push(tariffProduct);
                                    }
                                } else {
                                    tariffProductsNoDuplicateArr.push(tariffProduct);
                                }

                                tariffProductsArr.push(tariffProduct);
                            }
                        }

                        var defaultValue = null;
                        if (_this3.state.TariffProducts !== null && _this3.state.TariffProducts !== undefined) {
                            var ticket = document.getElementById('TariffProducts').options[document.getElementById("TariffProducts").selectedIndex].text;
                            var ticketIsInserted = false;
                            for (var _i4 = 0; _i4 < tariffProductsArr.length; _i4++) {
                                if (tariffProductsArr[_i4].Display === ticket) {
                                    ticketIsInserted = true;
                                }
                            }
                            if (ticketIsInserted === false) {
                                _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                                    Message: _this3.NotTicketText,
                                    Title: _Vas2.default.getText("Titles", "Note")
                                }), document.getElementById('messageContainer'));
                            } else {
                                defaultValue = ticket;
                            }
                        }

                        me.tariffProductInput.current.setState({ Data: tariffProductsNoDuplicateArr, Loading: false, Default: defaultValue }, function () {
                            localStorage.setItem('returnProducts', JSON.stringify(tariffProductsArr));
                            _this3.setTariff("Tickets", tariffProductsNoDuplicateArr);
                        });
                    } else {
                        _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                            Message: _this3.NotTicketText,
                            Title: _Vas2.default.getText("Titles", "Note")
                        }), document.getElementById('messageContainer'));
                    }
                }
                if (observer === "TariffPointFrom") {

                    var result = me.TariffPointsModelFrom.TariffPoints;
                    var resultArr = [];
                    var goOn = true;
                    if (_this3.state.SetDefault === true) {
                        goOn = false;
                    }
                    result.forEach(function (e) {
                        resultArr.push(e.DescriptionLong);
                        if (_this3.state.SetDefault === true) {
                            var flagSchuelerAbo = _this3.state.TariffProducts.split(";")[7] ? _this3.state.TariffProducts.split(";")[7] : "false";
                            if (flagSchuelerAbo === "true") {
                                if (_this3.DefaultSchueler === true) {
                                    var text = _this3.ConfigDefaults.DefaultSchuelerFromValue ? _this3.ConfigDefaults.DefaultSchuelerFromValue : "";
                                    if (_this3.Tariff) {
                                        if (_this3.Tariff[1]) {
                                            if (_this3.Tariff[1].DescriptionLong) {
                                                text = _this3.Tariff[1].DescriptionLong;
                                            }
                                        }
                                    }

                                    if (e.DescriptionLong === text) {
                                        goOn = true;
                                    }
                                } else {
                                    goOn = true;
                                }
                            } else {
                                if (_this3.DefaultSonst === true) {
                                    var _text = _this3.ConfigDefaults.DefaultSonstFromValue ? _this3.ConfigDefaults.DefaultSonstFromValue : "";
                                    if (_this3.Tariff) {
                                        if (_this3.Tariff[1]) {
                                            if (_this3.Tariff[1].DescriptionLong) {
                                                _text = _this3.Tariff[1].DescriptionLong;
                                            }
                                        }
                                    }

                                    if (e.DescriptionLong === _text) {
                                        goOn = true;
                                    }
                                }
                            }
                        }
                    });
                    me.From = result;
                    if (me.fromInput.current) {
                        if (goOn === true) {
                            me.fromInput.current.setState({ Data: resultArr, Loading: false, Icon: 'Close' }, function () {
                                _this3.setTariff("From");
                                _this3.setDefault("To");
                            });
                        } else {
                            me.fromInput.current.setState({ Data: [], Loading: false, Icon: 'Close' }, function () {
                                _this3.setDefault("To");
                            });
                        }
                    } else {
                        _this3.setTariff("Tickets", localStorage.getItem('returnProducts') ? JSON.parse(localStorage.getItem('returnProducts')) : me.tariffProductInput.current.Data);
                    }
                }
                if (observer === "TariffPointTo") {
                    var _result = me.TariffPointsModelTo.TariffPoints;
                    var _resultArr = [];
                    var _goOn = true;
                    if (_this3.state.SetDefault === true) {
                        _goOn = false;
                    }
                    _result.forEach(function (e) {
                        _resultArr.push(e.DescriptionLong);
                        if (_this3.state.SetDefault === true) {
                            var flagSchuelerAbo = _this3.state.TariffProducts.split(";")[7] ? _this3.state.TariffProducts.split(";")[7] : "false";
                            if (flagSchuelerAbo === "true") {
                                if (_this3.DefaultSchueler === true) {
                                    var text = _this3.ConfigDefaults.DefaultSchuelerToValue ? _this3.ConfigDefaults.DefaultSchuelerToValue : "";
                                    if (_this3.Tariff) {
                                        if (_this3.Tariff[2]) {
                                            if (_this3.Tariff[2].DescriptionLong) {
                                                text = _this3.Tariff[2].DescriptionLong;
                                            }
                                        }
                                    }

                                    if (e.DescriptionLong === text) {
                                        _goOn = true;
                                    }
                                } else {
                                    _goOn = true;
                                }
                            } else {
                                // if(this.DefaultSonst === true){
                                //     let text = this.ConfigDefaults.DefaultSonstToValue ? this.ConfigDefaults.DefaultSonstToValue : "";
                                //     if(this.Tariff){
                                //        if(this.Tariff[2]){
                                //             if(this.Tariff[2].DescriptionLong){
                                //                 text = this.Tariff[2].DescriptionLong;
                                //             }
                                //         } 
                                //     }

                                //     if(e.DescriptionLong === text){

                                //Anpassung betrifft Ticket VAS-28809
                                //Wenn bspw. Abokarte gewählt wird, wird Chemnitz, Stadt vorgeblendet -> soweit OK
                                //Wenn als Tarifpunkt Nach dann bspw. Burkhardtsdorf eingegeben wird, ohne hintaen auf das X zu klicken,
                                //Wird eine leere Liste zurückgegeben. 
                                //Hinweis: this.ConfigDefaults.DefaultSonstFromValue ist in dem Fall Chemnitz, Stadt
                                //e.DescriptionLong ist dem Fall Burkhardtsdorf
                                _goOn = true;

                                //     }
                                // }
                            }
                        }
                    });
                    me.To = _result;
                    if (_goOn === true) {
                        me.toInput.current.setState({ Data: _resultArr, Loading: false, Icon: 'Close' }, function () {
                            _this3.setTariff("To");
                            _this3.setDefault("Product");
                        });
                    } else {
                        me.toInput.current.setState({ Data: [], Loading: false, Icon: 'Close' }, function () {
                            _this3.setDefault("Product");
                        });
                    }
                }
                if (observer === "TariffProducts" || observer === "TariffProductsCustomerAbove") {
                    var _data = me.ProductModel.ProductList;
                    var vias = [];

                    var via = '';

                    for (var _i5 = 0; _i5 < _data.length; _i5++) {

                        if (_data[_i5].TzViaText != null || _data[_i5].TzViaText != "null" || _data[_i5].TzViaText != "Null") {
                            if (_this3.state.ShowPriceLevel) {
                                via = { Key: _data[_i5].Price + ";" + _data[_i5].PaymentInterval + ";" + _data[_i5].ContractEnd + ";" + _data[_i5].IdTicket + ";" + _data[_i5].IdMatrix + ";" + _data[_i5].Share1 + ";" + _data[_i5].Share2, Display: _data[_i5].TzViaText + " (" + _data[_i5].PriceLevel + ")" };
                            } else {
                                via = { Key: _data[_i5].Price + ";" + _data[_i5].PaymentInterval + ";" + _data[_i5].ContractEnd + ";" + _data[_i5].IdTicket + ";" + _data[_i5].IdMatrix + ";" + _data[_i5].Share1 + ";" + _data[_i5].Share2, Display: _data[_i5].TzViaText };
                            }

                            vias.push(via);
                        }
                    }
                    me.viaInput.current.setState({ Data: vias, Loading: false });
                    me.setState({ SetDefault: false });
                    _this3.setTariff("TariffProduct", vias);
                }
                if (observer === "MultimediaTextFromProduct") {
                    var multimediatextArr = [];
                    me.MultimediaTextModel.MultimediaText.forEach(function (value) {
                        multimediatextArr.push({ Display: value });
                    });

                    localStorage.setItem('MultimediaTexts', JSON.stringify(multimediatextArr));
                }
                if (observer === "MultimediaTextProduct") {
                    var _multimediatextArr = [];
                    me.MultimediaTextProductModel.MultimediaText.forEach(function (value) {
                        _multimediatextArr.push({ value: value });
                    });

                    localStorage.setItem('MultimediaTextProduct', JSON.stringify(_multimediatextArr));
                    me.setState({});
                }
                if (observer === "CustomersAbove") {
                    if (_this3.CustomerModel.CustomersAbove.length > 0) {
                        var _data2 = [];
                        for (var _i6 = 0; _i6 < _this3.CustomerModel.CustomersAbove.length; _i6++) {
                            var d = { Key: _this3.CustomerModel.CustomersAbove[_i6].Id,
                                Display: _this3.CustomerModel.CustomersAbove[_i6].Name };
                            _data2.push(d);
                        }

                        _this3.customerAboveInput.current.setState({ Data: _data2 });
                    }
                }
            });

            this.FontSizeClick();
            this.LogoClick();
        }
    }, {
        key: 'setTariff',
        value: function setTariff(field, dataArray) {
            var _this4 = this;

            var me = this;
            if (this.Tariff !== null && this.Tariff !== undefined) {
                if (field === "ContractStart") {

                    var idx = 0;
                    if (this.Tariff[1]) {
                        var contractStart = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(this.Tariff[1].ContractStart, true, localStorage.getItem('vas_language')));
                        for (var i = 0; i < dataArray.length; i++) {
                            if (dataArray[i].Display === contractStart) {
                                idx = i + 1;
                            }
                        }

                        document.getElementById('ContractStart').selectedIndex = idx;
                        var ticketName = this.Tariff[0].TicketName;

                        if (ticketName.indexOf("Motiv") > -1) {
                            ticketName = "Deutschlandticket Chipkarte";
                        }

                        this.setState({ ContractStart: contractStart }, function () {
                            var tariffProductsArr = JSON.parse(localStorage.getItem('returnProducts'));
                            var idxButton = 0;
                            var ticketId = '';
                            for (var _i7 = 0; _i7 < tariffProductsArr.length; _i7++) {
                                var product = tariffProductsArr[_i7].Display;
                                if (product === ticketName) {
                                    if (tariffProductsArr[_i7].Key.split(";")[2] === "true") {
                                        if (tariffProductsArr[_i7].Key.split(";")[8] === _this4.Tariff[0].PriceLevel) {
                                            idxButton = _i7 + 1;
                                            ticketId = tariffProductsArr[_i7].Key.split(";")[0];
                                        }
                                    } else {
                                        idxButton = _i7 + 1;
                                        ticketId = tariffProductsArr[_i7].Key.split(";")[0];
                                    }
                                }
                            }
                            if (_this4.Tariff[1] !== null && _this4.Tariff[1] !== undefined) {

                                if (localStorage.getItem('FixedRoute') === null || localStorage.getItem('FixedRoute') === undefined) {
                                    _this4.TariffPointsModelFrom.GetTariffPointsByTicketId(ticketId, _this4.Tariff[1].DescriptionShort, _this4.Tariff[1].ContractStart, "", _this4.state.ShowTariffPointIdent);
                                    (0, _jquery2.default)('#From').val(_this4.Tariff[1].DescriptionLong);
                                    //--> geht weiter in Update(observer):TariffPointsFrom
                                } else {
                                    if (_this4.Tariff[0].TicketName.indexOf("Motiv1") > -1) {
                                        document.getElementById("Motiv1").checked = true;
                                    } else if (_this4.Tariff[0].TicketName.indexOf("Motiv2") > -1) {
                                        document.getElementById("Motiv2").checked = true;
                                    } else if (_this4.Tariff[0].TicketName.indexOf("Motiv3") > -1) {
                                        document.getElementById("Motiv3").checked = true;
                                    }
                                    //this.setVisible("Product");
                                    _this4.setPriceAndContractEndFixedRoute("i-" + (idxButton - 1));

                                    var buttons = document.getElementsByClassName("selectedButton");
                                    for (var _i8 = 0; _i8 < buttons.length; _i8++) {
                                        buttons[_i8].classList.remove('selectedButton');
                                    }

                                    if (document.getElementById("i-" + (idxButton - 1))) {
                                        document.getElementById("i-" + (idxButton - 1)).classList.add('selectedButton');
                                    }

                                    _reactDom2.default.unmountComponentAtNode(document.getElementById('popupContainer'));
                                }
                            } else {
                                localStorage.removeItem('Tariff');
                                _this4.Tariff = null;
                                _reactDom2.default.unmountComponentAtNode(document.getElementById('popupContainer'));
                            }
                        });
                    } else {
                        _reactDom2.default.unmountComponentAtNode(document.getElementById('popupContainer'));
                    }
                } else if (field === "Clients") {
                    if (this.ShowClientsBox === false) {
                        this.setState({ AboCenter: dataArray[0].Key }, function () {
                            _this4.GetTickets();
                        });
                        //->>weiter bei Update(observer):Tickets
                    } else {
                        this.CustomerClientModel.GetClientById(localStorage.getItem('vas_clientId'));
                        //->> weiter bei Update(observer):Client
                    }
                } else if (field === "Tickets") {
                    _reactDom2.default.render(_react2.default.createElement(_Loading2.default, { modal: true }), document.getElementById('popupContainer'));
                    var _idx = 0;
                    var idxButton = 0;
                    var ticketId = '';
                    var tariffProductsArr = JSON.parse(localStorage.getItem('returnProducts'));

                    //console.log(dataArray); // Produkte laut Auswahl mit D-Ticket Chipkarte
                    //console.log(this.Tariff[0]); //Produkt D-Ticket Motiv X
                    var ticketName = this.Tariff[0].TicketName;

                    if (ticketName.indexOf("Motiv") > -1) {
                        ticketName = "Deutschlandticket Chipkarte";
                    }

                    for (var _i9 = 0; _i9 < dataArray.length; _i9++) {
                        var product = dataArray[_i9].Display;
                        if (product === ticketName) {
                            /*if(dataArray[i].Key.split(";")[2] === "true"){
                                if(dataArray[i].Key.split(";")[8] === this.Tariff[0].PriceLevel){
                                    idx = i +1;
                                    ticketId = dataArray[i].Key.split(";")[0];
                                }
                            }else{
                                idx = i +1;
                                ticketId = dataArray[i].Key.split(";")[0];  
                            }*/
                            _idx = _i9 + 1;
                        }
                    }

                    for (var _i10 = 0; _i10 < tariffProductsArr.length; _i10++) {
                        var _product = tariffProductsArr[_i10].Display;
                        if (_product === ticketName) {
                            if (tariffProductsArr[_i10].Key.split(";")[2] === "true") {
                                if (tariffProductsArr[_i10].Key.split(";")[8] === this.Tariff[0].PriceLevel) {
                                    idxButton = _i10 + 1;
                                    ticketId = tariffProductsArr[_i10].Key.split(";")[0];
                                }
                            } else {
                                idxButton = _i10 + 1;
                                ticketId = tariffProductsArr[_i10].Key.split(";")[0];
                            }
                        }
                    }
                    document.getElementById('TariffProducts').selectedIndex = _idx;

                    if (this.ContractId !== "00000") {
                        this.ContractStartParamsModel.GetContractStartParamsByContractId(this.ContractId, ticketId);
                    } else {
                        this.ContractStartParamsModel.GetContractStartParamsByTicketId(ticketId);
                    }

                    this.MultimediaTextProductModel.GetMultimediaTextFromTicketId(ticketId);

                    me.setState({ TariffProducts: dataArray[_idx - 1].Key });
                } else if (field === "From") {
                    this.TariffPointsModelFrom.SelectedTariffId = this.GetTariffPointOfArray(document.getElementById('From').value, this.TariffPointsModelFrom.TariffPoints);

                    var _tariffProductsArr = document.getElementById('TariffProducts').value;

                    var _ticketId = _tariffProductsArr.split(";")[0];

                    this.TariffPointsModelTo.GetTariffPointsByTicketId(_ticketId, this.Tariff[2].DescriptionShort, this.Tariff[2].ContractStart, "", this.state.ShowTariffPointIdent);
                    (0, _jquery2.default)('#To').val(this.Tariff[2].DescriptionLong);

                    //--> geht weiter in Update(observer):TariffPointTo
                } else if (field === "To") {
                    (0, _jquery2.default)("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
                    var x = document.getElementsByClassName("autocomplete-items");
                    for (var _i11 = 0; _i11 < x.length; _i11++) {
                        x[_i11].parentNode.removeChild(x[_i11]);
                    }
                    this.TariffPointsModelTo.SelectedTariffId = this.GetTariffPointOfArray(document.getElementById('To').value, this.TariffPointsModelTo.TariffPoints);
                } else if (field === "TariffProduct") {

                    var viaText = this.Tariff[0].TzViaText;

                    //Wenn die Preisstufe mit angezeigt werden soll, muss sie beim ViaText mit ergänzt werden
                    if (this.state.ShowPriceLevel) {
                        viaText = viaText + ' (' + this.Tariff[0].PriceLevel + ')';
                    }

                    var _idx2 = 0;
                    for (var _i12 = 0; _i12 < dataArray.length; _i12++) {
                        if (dataArray[_i12].Display === viaText) {
                            _idx2 = _i12;
                        }
                    }

                    this.setState({ Via: dataArray[_idx2].Key }, function () {
                        document.getElementById("Via").selectedIndex = _idx2 + 1;
                        _this4.setVisible("setTariff");

                        _this4.setPriceAndContractEnd();
                        _this4.doAfterProducts((0, _jquery2.default)("#Via").val().split(';'));

                        _reactDom2.default.unmountComponentAtNode(document.getElementById('popupContainer'));
                    });
                }
            }
        }
    }, {
        key: 'setVisible',
        value: function setVisible(field, origin) {
            localStorage.removeItem('MultimediaTexts');
            //localStorage.removeItem('MultimediaTextProduct');
            localStorage.removeItem('Tariff');

            var aboCenter = null;
            if (this.ShowClientsBox === true) {
                aboCenter = document.getElementById("AboCenter");
            }

            if (field === "ContractStart") {
                if (aboCenter !== null) {
                    //AboCenter soll angezeigt werden
                    aboCenter.selectedIndex = 0;
                    this.TariffProductsModel.ProductList = [];
                    this.tariffProductInput.current.setState({ Data: [] });
                    (0, _jquery2.default)('#From').val('');
                    (0, _jquery2.default)('#To').val('');
                    if (localStorage.getItem('FixedRoute') === null || localStorage.getItem('FixedRoute') === undefined) {
                        this.fromInput.current.setState({ Data: [], editable: false });
                        this.toInput.current.setState({ Data: [], editable: false });
                        this.viaInput.current.setState({ Icon: "", Data: null, editable: false });
                    }
                } else {
                    // AboCenter soll nicht angezeigt werden
                    //this.TariffProductsModel.ProductList = [];
                    //this.tariffProductInput.current.setState({Data:[]});
                    (0, _jquery2.default)('#From').val('');

                    if (this.deleteRelationTo) {
                        (0, _jquery2.default)('#To').val('');
                    }

                    if (localStorage.getItem('FixedRoute') === null || localStorage.getItem('FixedRoute') === undefined) {
                        this.fromInput.current.setState({ Data: [], editable: true });
                        this.toInput.current.setState({ Data: [], editable: false });
                        this.viaInput.current.setState({ Icon: "", Data: null, editable: false });
                    }
                    this.GetTickets();
                }
            } else if (field === "AboCenter") {
                this.TariffProductsModel.ProductList = [];
                this.tariffProductInput.current.setState({ Data: [] });
                (0, _jquery2.default)('#From').val('');
                (0, _jquery2.default)('#To').val('');
                this.fromInput.current.setState({ Data: [], editable: false });
                this.toInput.current.setState({ Data: [], editable: false });
                this.viaInput.current.setState({ Icon: "", Data: null, editable: false });
            } else if (field === "Product") {
                (0, _jquery2.default)('#From').val('');
                (0, _jquery2.default)('#To').val('');

                if (localStorage.getItem('FixedRoute') === null || localStorage.getItem('FixedRoute') === undefined) {
                    this.fromInput.current.setState({ Data: [], editable: false });
                    this.toInput.current.setState({ Data: [], editable: false });
                    this.viaInput.current.setState({ Icon: "", Data: null, editable: false });
                }
            } else if (field === "From") {

                if (origin == "To") {
                    (0, _jquery2.default)('#To').val('');
                }

                this.toInput.current.setState({ Data: [], editable: true });
                this.viaInput.current.setState({ Icon: "", Data: null, editable: false });
            } else if (field === "To") {
                this.viaInput.current.setState({ Icon: "", Data: null });
            } else if (field === "setTariff") {
                this.fromInput.current.setState({ editable: true });
                this.toInput.current.setState({ editable: true });
            } else if (field === "CustomerAbove") {
                this.TariffProductsModel.ProductList = [];
                this.tariffProductInput.current.setState({ Data: [] });
                (0, _jquery2.default)('#From').val('');
                (0, _jquery2.default)('#To').val('');
                this.fromInput.current.setState({ Data: [], editable: false });
                this.toInput.current.setState({ Data: [], editable: false });
                this.viaInput.current.setState({ Icon: "", Data: null, editable: false });
            }

            if (document.getElementById("TariffProducts").selectedIndex > 0) {

                if ((0, _jquery2.default)("#TariffProducts").val() !== null && (0, _jquery2.default)("#TariffProducts").val() !== undefined) {
                    var tariffProductsArr = (0, _jquery2.default)("#TariffProducts").val().split(';');

                    localStorage.setItem('AddFellowPassenger', tariffProductsArr[1]);

                    this.removePriceAndContractEnd();
                    this.removeTraversedZones();
                    if ((0, _jquery2.default)("#TariffProducts option:selected").text() === ' Senioren-Abo Netz 1. Kl. pers.') {
                        this.SetHint();
                    }
                }
            }
        }
    }, {
        key: 'setDefault',
        value: function setDefault(field) {
            if (this.Tariff === null || this.Tariff === undefined) {
                if (this.state.SetDefault === true) {
                    if (this.state.TariffProducts === null || this.state.TariffProducts === undefined) {
                        document.getElementById("ContractStart").selectedIndex = 0;
                        _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                            Message: this.ProductFirstText,
                            Title: _Vas2.default.getText("Titles", "Note")
                        }), document.getElementById('messageContainer'));
                    } else {

                        var e = document.getElementById("TariffProducts");
                        var text = e.options[e.selectedIndex].text;
                        if (text == "Deutschlandticket Chipkarte") {
                            if (document.getElementById("Motiv1") != undefined && document.getElementById("Motiv1") != null && document.getElementById("Motiv1").checked) {
                                var test = JSON.parse(localStorage.getItem('Motiv1'))[0];
                                var multiUserCountAdult = 0;
                                var multiUserCountChild = 0;

                                if (test.MultiUserCountAdult !== null) {
                                    if (test.MultiUserCountAdult > 0) {
                                        multiUserCountAdult = test.MultiUserCountAdult - 1;
                                    } else {
                                        multiUserCountAdult = test.MultiUserCountAdult;
                                    }
                                }

                                if (test.MultiUserCountChild !== null) {
                                    multiUserCountChild = test.MultiUserCountChild;
                                }

                                this.state.TariffProducts = test.IdTicket + ";" + test.FlagMultiUser + ";" + test.FixedRoute + ";" + multiUserCountAdult + ";" + multiUserCountChild + ";" + test.Share1 + ";" + test.Share2 + ";" + test.FlagSchuelerAbo + ";" + test.PriceLevel;
                            }
                        }

                        var flagSchuelerAbo = this.state.TariffProducts.split(";")[7] ? this.state.TariffProducts.split(";")[7] : "false";
                        var from = '';
                        var to = '';
                        if (localStorage.getItem('FixedRoute') === null || localStorage.getItem('FixedRoute') === undefined) {
                            if (flagSchuelerAbo === "true") {
                                if (this.DefaultSchueler === true) {
                                    from = this.ConfigDefaults.DefaultSchuelerFromValue ? this.ConfigDefaults.DefaultSchuelerFromValue : "";
                                    to = this.ConfigDefaults.DefaultSchuelerToValue ? this.ConfigDefaults.DefaultSchuelerToValue : "";
                                }
                            } else {
                                if (this.DefaultSonst === true) {
                                    from = this.ConfigDefaults.DefaultSonstFromValue ? this.ConfigDefaults.DefaultSonstFromValue : "";
                                    to = this.ConfigDefaults.DefaultSonstToValue ? this.ConfigDefaults.DefaultSonstToValue : "";
                                }
                            }

                            if (field === "From") {
                                if (from !== "") {
                                    _reactDom2.default.render(_react2.default.createElement(_Loading2.default, { modal: true }), document.getElementById('popupContainer'));
                                }

                                document.getElementById("From").value = from;
                                this.setVisible("From");
                                this.Search("From");
                            } else if (field === "To") {
                                document.getElementById("To").value = to;
                                this.setVisible("To");
                                this.Search("To");
                            } else if (field === "Product") {
                                this.GetProduct();
                                _reactDom2.default.unmountComponentAtNode(document.getElementById('popupContainer'));
                            }
                        }
                    }
                }
            }
        }
        //#endregion

        //#region price

    }, {
        key: 'removePriceAndContractEnd',
        value: function removePriceAndContractEnd() {
            //Aufruf, wenn To in Preisinformation zuvor gecleared wurde
            (0, _jquery2.default)("#Price").val('');
            this.priceInput.current.setState({ Value: '', Label: _Vas2.default.getText("Labels", "ProductPrice") + " " + _Vas2.default.getText("Labels", "inEuro") });
            if (this.ShowContractEnd === true) {
                if (this.contractEndInput.current !== null && this.contractEndInput !== undefined) {
                    (0, _jquery2.default)("#ContractEnd").val('');
                    //this.contractEndInput.current.setState({ Value:'' });
                }
            }
        }
    }, {
        key: 'SetPaymentIntervall',
        value: function SetPaymentIntervall(paymentIntervall) {
            var priceInfoDefault = " " + _Vas2.default.getText("Labels", "inEuro");
            var priceInfo = '';

            switch (paymentIntervall) {
                case "1":
                    priceInfo = _Vas2.default.getText("Labels", "WeeklyPrice") + " " + priceInfoDefault;
                    break;
                case "2":
                    priceInfo = _Vas2.default.getText("Labels", "BiweeklyPrice") + " " + priceInfoDefault;
                    break;
                case "3":
                default:
                    priceInfo = _Vas2.default.getText("Labels", "MonthlyPrice") + " " + priceInfoDefault;
                    break;
                case "4":
                    priceInfo = _Vas2.default.getText("Labels", "QuarterlyPrice") + " " + priceInfoDefault;
                    break;
                case "5":
                    priceInfo = _Vas2.default.getText("Labels", "SemiannualPrice") + " " + priceInfoDefault;
                    break;
                case "6":
                    priceInfo = _Vas2.default.getText("Labels", "AnnualPrice") + " " + priceInfoDefault;
                    break;
            }

            this.priceInput.current.setState({ Label: priceInfo });
        }
    }, {
        key: 'setPriceAndContractEnd',
        value: function setPriceAndContractEnd() {
            //Holt den Preis des gewählten TariffProducts und gibt diesen aus
            if (document.getElementById("Via").selectedIndex > 0) {

                var priceInfoArr = (0, _jquery2.default)("#Via").val().split(';');

                this.SetPaymentIntervall(priceInfoArr[1]);

                this.priceInput.current.setState({ Value: _utilsLib.CurrencyConverter.Cast(priceInfoArr[0], localStorage.getItem('vas_language'), 2) });

                if (this.ShowContractEnd === true) {
                    if (this.ConfigContractEnd.ChangeContractEnd === true) {

                        var subMonths = 0;
                        if (this.ConfigContractEnd.ShowDay === false) {
                            subMonths = 1;
                        }

                        if (priceInfoArr[2] !== 'null') {
                            if (this.Tariff) {
                                if (this.Tariff[0]) {
                                    if (this.Tariff[0].ContractEnd !== null) {
                                        if (this.state.ShowDay === true) {
                                            document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(this.Tariff[0].ContractEnd, true, localStorage.getItem('vas_language')));
                                        } else {
                                            document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(this.Tariff[0].ContractEnd, true, localStorage.getItem('vas_language'))).substring(3);
                                        }
                                    } else {
                                        if (this.state.ShowDay === true) {
                                            document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(priceInfoArr[2], true, localStorage.getItem('vas_language')));
                                        } else {
                                            document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(priceInfoArr[2], true, localStorage.getItem('vas_language'))).substring(3);
                                        }
                                    }
                                } else {
                                    if (this.state.ShowDay === true) {
                                        document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(priceInfoArr[2], true, localStorage.getItem('vas_language')));
                                    } else {
                                        document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(priceInfoArr[2], true, localStorage.getItem('vas_language'))).substring(3);
                                    }
                                }
                            } else {
                                if (this.state.ShowDay === true) {
                                    document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(priceInfoArr[2], true, localStorage.getItem('vas_language')));
                                } else {
                                    document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(priceInfoArr[2], true, localStorage.getItem('vas_language'))).substring(3);
                                }
                            }

                            var maxdate = _utilsLib.DateTimeHelper.StringToDate(priceInfoArr[2], true, localStorage.getItem('vas_language'));
                            var mindate = _utilsLib.DateTimeHelper.StringToDate(this.state.ContractStart, false, localStorage.getItem('vas_language')).add(this.ProductModel.ProductList[document.getElementById("Via").selectedIndex - 1].MinimumRuntime - subMonths, 'months');
                            if (mindate.isSameOrAfter(maxdate, 'day') === true) {
                                mindate = maxdate.subtract(1, 'day');
                            }

                            this.contractEndInput.current.setState({ MaxValue: moment([maxdate.year(), maxdate.month(), maxdate.date() + 1]),
                                MinValue: moment([mindate.year(), mindate.month(), mindate.date() + 1]) });
                        } else {
                            if (this.Tariff) {
                                if (this.Tariff[0]) {
                                    if (this.Tariff[0].ContractEnd !== null) {
                                        if (this.state.ShowDay === true) {
                                            document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(this.Tariff[0].ContractEnd, true, localStorage.getItem('vas_language')));
                                        } else {
                                            document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(this.Tariff[0].ContractEnd, true, localStorage.getItem('vas_language'))).substring(3);
                                        }
                                    }
                                }
                            }

                            var _mindate = _utilsLib.DateTimeHelper.StringToDate(this.state.ContractStart, false, localStorage.getItem('vas_language')).add(this.ProductModel.ProductList[document.getElementById("Via").selectedIndex - 1].MinimumRuntime - subMonths, 'months');
                            this.contractEndInput.current.setState({ MinValue: moment([_mindate.year(), _mindate.month(), _mindate.date()]),
                                MaxValue: null
                            });
                        }
                        var cur = _utilsLib.DateTimeHelper.StringToDate((0, _jquery2.default)("#ContractEnd").val(), false, localStorage.getItem('vas_language'));
                        if (this.ConfigContractEnd.ShowDay === false) {
                            var val = '01.' + (0, _jquery2.default)("#ContractEnd").val();
                            cur = _utilsLib.DateTimeHelper.StringToDate(val, false, localStorage.getItem('vas_language'));
                        }
                        var curMoment = moment([cur.year(), cur.month(), cur.date()]);
                        if (curMoment.isSameOrBefore(moment(), 'day')) {
                            this.setState({ ContractEnd: null });
                        } else {
                            if (this.ConfigContractEnd.ShowDay === false) {
                                curMoment.date(_utilsLib.DateTimeHelper.GetLastDayOfMonth(curMoment.month(), curMoment.year()));
                            }
                            this.setState({ ContractEnd: curMoment.format("YYYY-MM-DDT00:00:00") });
                        }
                    } else {
                        this.contractEndInput.current.setState({ Value: priceInfoArr[2] !== 'null' ? _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(priceInfoArr[2], true, localStorage.getItem('vas_language'))) : _Vas2.default.getText('Labels', 'Unlimited') });
                        var _cur = _utilsLib.DateTimeHelper.StringToDate(priceInfoArr[2] !== 'null' ? _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(priceInfoArr[2], true, localStorage.getItem('vas_language'))) : _utilsLib.DateTimeHelper.FormatToShortDateString(moment()), false, localStorage.getItem('vas_language'));
                        var _curMoment = moment([_cur.year(), _cur.month(), _cur.date()]);
                        if (_curMoment.isSameOrBefore(moment(), 'day')) {
                            this.setState({ ContractEnd: null });
                        } else {
                            this.setState({ ContractEnd: _curMoment.format("YYYY-MM-DDT00:00:00") });
                        }
                    }
                }
            } else {
                this.priceInput.current.setState({ Value: '' });
                if (this.ShowContractEnd === true) {
                    this.contractEndInput.current.setState({ Value: '' });
                }
            }
        }
    }, {
        key: 'setPriceAndContractEndFixedRoute',
        value: function setPriceAndContractEndFixedRoute(id) {
            var idArray = id.split('-');

            var tariffProductsArray = localStorage.getItem('TariffProducts') !== null && localStorage.getItem('TariffProducts') !== undefined ? JSON.parse(localStorage.getItem('TariffProducts')) : [];

            this.SetPaymentIntervall(tariffProductsArray[idArray[1]].PaymentInterval);

            this.priceInput.current.setState({ Value: _utilsLib.CurrencyConverter.Cast(tariffProductsArray[idArray[1]].Price, localStorage.getItem('vas_language'), 2) });

            if (this.ShowContractEnd === true) {
                if (this.ConfigContractEnd.ChangeContractEnd === true) {
                    var subMonths = 0;
                    if (this.ConfigContractEnd.ShowDay === false) {
                        subMonths = 1;
                    }
                    if (tariffProductsArray[idArray[1]].ContractEnd !== null) {
                        if (this.Tariff) {
                            if (this.Tariff[0]) {
                                if (this.Tariff[0].ContractEnd !== null) {
                                    if (this.state.ShowDay === true) {
                                        document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(this.Tariff[0].ContractEnd, true, localStorage.getItem('vas_language')));
                                    } else {
                                        document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(this.Tariff[0].ContractEnd, true, localStorage.getItem('vas_language'))).substring(3);
                                    }
                                } else {}
                            } else {
                                if (this.state.ShowDay === true) {
                                    document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(tariffProductsArray[idArray[1]].ContractEnd, true, localStorage.getItem('vas_language')));
                                } else {
                                    document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(tariffProductsArray[idArray[1]].ContractEnd, true, localStorage.getItem('vas_language'))).substring(3);
                                }
                            }
                        } else {
                            if (this.state.ShowDay === true) {
                                document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(tariffProductsArray[idArray[1]].ContractEnd, true, localStorage.getItem('vas_language')));
                            } else {
                                document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(tariffProductsArray[idArray[1]].ContractEnd, true, localStorage.getItem('vas_language'))).substring(3);
                            }
                        }
                        var maxValue = _utilsLib.DateTimeHelper.StringToDate(tariffProductsArray[idArray[1]].ContractEnd, true, localStorage.getItem('vas_language'));
                        var minValue = _utilsLib.DateTimeHelper.StringToDate(this.state.ContractStart, false, localStorage.getItem('vas_language')).add(tariffProductsArray[idArray[1]].MinimumRuntime - subMonths, 'months');

                        this.contractEndInput.current.setState({ MaxValue: moment([maxValue.year(), maxValue.month(), maxValue.date()]),
                            MinValue: moment([minValue.year(), minValue.month(), minValue.date()])
                        });
                    } else {
                        if (this.Tariff) {
                            if (this.Tariff[0]) {
                                if (this.Tariff[0].ContractEnd !== null) {
                                    if (this.state.ShowDay === true) {
                                        document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(this.Tariff[0].ContractEnd, true, localStorage.getItem('vas_language')));
                                    } else {
                                        document.getElementById('ContractEnd').value = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(this.Tariff[0].ContractEnd, true, localStorage.getItem('vas_language'))).substring(3);
                                    }
                                }
                            }
                        }

                        var _minValue = _utilsLib.DateTimeHelper.StringToDate(this.state.ContractStart, false, localStorage.getItem('vas_language')).add(tariffProductsArray[idArray[1]].MinimumRuntime - subMonths, 'months');

                        this.contractEndInput.current.setState({ MinValue: moment([_minValue.year(), _minValue.month(), _minValue.date()]),
                            MaxValue: null
                        });
                    }
                } else {
                    this.contractEndInput.current.setState({ Value: tariffProductsArray[idArray[1]].ContractEnd !== null ? _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(tariffProductsArray[idArray[1]].ContractEnd, true, localStorage.getItem('vas_language'))) : _Vas2.default.getText("Labels", "Unlimited") });
                }
            }

            localStorage.setItem('TariffProduct', JSON.stringify(tariffProductsArray[idArray[1]]));
            // ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));

            this.FontSizeClick();
        }

        //#endregion

        //#region traversed Zones

    }, {
        key: 'showTraversedZones',
        value: function showTraversedZones(traversedZones) {
            var _this5 = this;

            this.removeTraversedZones();
            if (traversedZones !== null && traversedZones !== undefined) {
                var Zones = [];
                var Waben = [];

                for (var i = 0; i < traversedZones.length; i++) {
                    //Waben.push(traversedZones[i].Description.substring(0,1).toUpperCase() + traversedZones[i].Description.substring(1).toLowerCase());
                    Waben.push(traversedZones[i].Description);
                }
                Waben.sort();

                for (var _i13 = 0; _i13 < Waben.length; _i13++) {
                    var zone = _react2.default.createElement(
                        'div',
                        { key: _i13 },
                        Waben[_i13]
                    );
                    Zones.push(zone);
                }

                if (Waben.length > 0) {

                    (0, _jquery2.default)('#TraversedZonesArea').removeClass().addClass('display');

                    _reactDom2.default.render(_react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                {
                                    id: "TraversedZones",
                                    className: "TicketBoxTitle",
                                    onClick: function onClick() {
                                        _this5.ToggleDetails('TraversedZones');
                                    } },
                                _react2.default.createElement(
                                    'div',
                                    {
                                        id: "KeyboardArrowRightKontakt",
                                        className: "Show" },
                                    _react2.default.createElement(_Icon2.default, {
                                        Name: "KeyboardArrowRight",
                                        Size: 36,
                                        Color: "black",
                                        Align: "left" })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    {
                                        id: "KeyboardArrowDownKontakt",
                                        className: "Hide" },
                                    _react2.default.createElement(_Icon2.default, {
                                        Name: "KeyboardArrowDown",
                                        Size: 36,
                                        Color: "black",
                                        Align: "left" })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { style: { paddingTop: '1px' } },
                                    _Vas2.default.getText("Labels", "TraversedZones")
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                {
                                    id: "TraversedZonesDetails",
                                    className: "Hide" },
                                _react2.default.createElement(
                                    'div',
                                    { className: "TicketBoxText" },
                                    _react2.default.createElement(
                                        'table',
                                        null,
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    Zones
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement('br', null)
                    ), document.getElementById('TraversedZonesArea'));
                }
            }
        }
    }, {
        key: 'removeTraversedZones',
        value: function removeTraversedZones(id) {
            if (document.getElementById('TraversedZonesArea')) {
                //ReactDOM.unmountComponentAtNode(document.getElementById('TraversedZones'));
                (0, _jquery2.default)('#TraversedZonesArea').removeClass().addClass('hide');
            }
        }
    }, {
        key: 'traversedZones',
        value: function traversedZones() {

            var data = this.ProductModel.ProductList[0];
            this.showTraversedZones(data.TraversedZones);
        }
    }, {
        key: 'ToggleDetails',
        value: function ToggleDetails(id) {

            if ((0, _jquery2.default)("#" + id + "Details").hasClass('Show')) {
                (0, _jquery2.default)("#" + id + "Details").removeClass().addClass('Hide');

                (0, _jquery2.default)("#KeyboardArrowRight" + id).removeClass().addClass('Show');

                (0, _jquery2.default)("#KeyboardArrowDown" + id).removeClass().addClass('Hide');
            } else {
                (0, _jquery2.default)("#" + id + "Details").removeClass().addClass('Show');

                (0, _jquery2.default)("#KeyboardArrowRight" + id).removeClass().addClass('Hide');

                (0, _jquery2.default)("#KeyboardArrowDown" + id).removeClass().addClass('Show');
            }
        }

        //#endregion

        //#region check Fields

    }, {
        key: 'goToFirstUnfilled',
        value: function goToFirstUnfilled() {
            var result = _utilsLib.CheckFields.CheckTextFields(this.state.requiredFields, null);

            result = _utilsLib.CheckFields.CheckSelectFields(this.state.requiredSelectField, result[1]);
            result = _utilsLib.CheckFields.CheckTextFields(this.state.contractEndField, result[1]);

            if (result.length === 2) {
                _utilsLib.Jump.jump(null, null, null, null, result[1]);
            }
        }
    }, {
        key: 'checkFields',
        value: function checkFields() {
            //überprüft Pflichtfelder, ob geprüft
            if (localStorage.getItem('FixedRoute') !== null && localStorage.getItem('FixedRoute') !== undefined && localStorage.getItem('FixedRoute') === "true") {
                if (this.state.selectFieldsFixedRoute && this.state.contractEndField) {
                    var filled = _utilsLib.CheckFields.CheckFields(null, null, null, null, null, this.state.contractEndField, this.state.selectFieldsFixedRoute);
                    return filled;
                }
            } else {

                if (this.state.requiredFields && this.state.requiredSelectField && this.state.contractEndField) {
                    var _filled = _utilsLib.CheckFields.CheckFields(null, null, null, null, null, this.state.requiredFields, this.state.requiredSelectField);
                    var filled2 = _utilsLib.CheckFields.CheckFields(null, null, null, null, null, this.state.contractEndField, null);
                    return _filled[0] && filled2[0] ? [true] : [false];
                }
            }
        }
    }, {
        key: 'doAfterProducts',
        value: function doAfterProducts(values) {
            if (this.MethodAfterProducts !== null) {
                this.MethodAfterProducts(values);
            }
        }
    }, {
        key: 'doAfterTickets',
        value: function doAfterTickets(ticketId) {
            if (this.MethodAfterTickets !== null) {
                this.MethodAfterTickets(ticketId);
            }
        }
        //#endregion


        //#region tickets

    }, {
        key: 'GetTickets',
        value: function GetTickets() {
            //Abfrage der Tarifprodukte anhand des gewählten Abocenters
            //Hier das Flag für die feste Fahrstrecke mit ergänzen
            var goForward = false;
            if (this.ShowClientsBox === true) {
                if (document.getElementById("AboCenter").selectedIndex > 0) {
                    goForward = true;
                }
            } else {
                goForward = true;
            }
            if (goForward === true) {

                //this.tariffProductInput.current.setState({ Loading:true },()=>{
                var curContractStart = moment();
                if (this.state.ContractStart !== null && this.state.ContractStart !== undefined) {
                    curContractStart = _utilsLib.DateTimeHelper.StringToDate(this.state.ContractStart, false, localStorage.getItem('vas_language'));
                }

                var me = this;

                this.Request.setErrorHandler(function () {
                    me.tariffProductInput.current.setState({ Loading: false });
                });
                if (this.role === "1") {

                    if (localStorage.getItem("DayOfBirth")) {
                        this.TariffProductsModel.GetTicketsWithBirthDate(this.state.AboCenter, moment([curContractStart.year(), curContractStart.month(), curContractStart.date()]).format("YYYY-MM-DD T 00:00:00"), localStorage.getItem("DayOfBirth"));
                    } else {
                        this.TariffProductsModel.GetTickets(this.state.AboCenter, moment([curContractStart.year(), curContractStart.month(), curContractStart.date()]).format("YYYY-MM-DD T 00:00:00"));
                    }
                } else if (this.role === "3") {
                    this.TariffProductsModel.GetTicketsWithCustomerAbove(this.state.AboCenter, moment([curContractStart.year(), curContractStart.month(), curContractStart.date()]).format("YYYY-MM-DD T 00:00:00"), this.state.CustomerAbove);
                }

                //});
            }
        }

        //#endregion

        //#region tariff points

    }, {
        key: 'Search',
        value: function Search(field) {
            var me = this;
            if ((0, _jquery2.default)("#" + field).val().length >= me.TariffPointSearchlegth) {

                var search = (0, _jquery2.default)("#" + field).val();

                if (search == this.ConfigDefaults.DefaultSonstFromValue || search == this.ConfigDefaults.DefaultSonstToValue) {
                    search = "Chemnitz, Stadt";
                }

                this.TimeOutTime = window.setTimeout(function () {
                    me.GetTariffPoints(search, field);
                }, 1000);
            } else {
                if ((0, _jquery2.default)("#" + field).val().length === 0) {
                    this.viaInput.current.setState({ Data: null });
                    this.removePriceAndContractEnd();
                }
            }
        }
    }, {
        key: 'GetTariffPoints',
        value: function GetTariffPoints(search, tariffPointFieldId) {
            var _this6 = this;

            //Suche des Tarifpunkts Von bzw. Nach

            var me = this;
            var curContractStart = _utilsLib.DateTimeHelper.StringToDate(this.state.ContractStart, false, localStorage.getItem('vas_language'));
            if ((0, _jquery2.default)("#TariffProducts").val() !== null && (0, _jquery2.default)("#TariffProducts").val() !== undefined) {
                var tariffProductsArr = (0, _jquery2.default)("#TariffProducts").val().split(';');
                var tariffPointId = "";

                //Wenn Der Tarifpunkt Von bereits gewählt wurde, wird hier dessen Id mit übergeben
                if (tariffPointFieldId === "To") {

                    for (var i = 0; i < this.TariffPointsModelFrom.TariffPoints.length; i++) {
                        if (this.TariffPointsModelFrom.TariffPoints[i].DescriptionLong === (0, _jquery2.default)("#From").val()) {
                            tariffPointId = this.TariffPointsModelFrom.TariffPoints[i].Id;
                            break;
                        }
                    }

                    me.toInput.current.setState({ Loading: true, Icon: null, Data: [] }, function () {

                        _this6.Request2.setErrorHandler(function () {
                            me.toInput.current.setState({ Loading: false });
                        });
                        _this6.TariffPointsModelTo.TariffPoints = [];
                        if (_this6.role === "1") {
                            _this6.TariffPointsModelTo.GetTariffPointsByTicketId(tariffProductsArr[0], search, moment([curContractStart.year(), curContractStart.month(), curContractStart.date()]).format("YYYY-MM-DD T 00:00:00"), tariffPointId, _this6.state.ShowTariffPointIdent);
                        } else if (_this6.role === "3") {
                            _this6.TariffPointsModelTo.GetTariffPointsByTicketIdWithCustomerAbove(tariffProductsArr[0], search, moment([curContractStart.year(), curContractStart.month(), curContractStart.date()]).format("YYYY-MM-DD T 00:00:00"), tariffPointId, _this6.state.CustomerAbove);
                        }
                    });
                } else {
                    me.fromInput.current.setState({ Loading: true, Icon: null, Data: [] }, function () {

                        _this6.Request.setErrorHandler(function () {
                            me.fromInput.current.setState({ Loading: false });
                        });
                        _this6.TariffPointsModelFrom.TariffPoints = [];
                        if (_this6.role === "1") {
                            _this6.TariffPointsModelFrom.GetTariffPointsByTicketId(tariffProductsArr[0], search, moment([curContractStart.year(), curContractStart.month(), curContractStart.date()]).format("YYYY-MM-DD T 00:00:00"), tariffPointId, _this6.state.ShowTariffPointIdent);
                        } else if (_this6.role === "3") {
                            _this6.TariffPointsModelFrom.GetTariffPointsByTicketIdWithCustomerAbove(tariffProductsArr[0], search, moment([curContractStart.year(), curContractStart.month(), curContractStart.date()]).format("YYYY-MM-DD T 00:00:00"), tariffPointId, _this6.state.CustomerAbove);
                        }
                    });
                }
            }
        }
    }, {
        key: 'GetTariffPointOfArray',
        value: function GetTariffPointOfArray(tariffPoint, tariffPoints) {
            var idx = -1;
            for (var i = 0; i < tariffPoints.length; i++) {

                if (tariffPoint === tariffPoints[i].DescriptionLong) {
                    idx = i;
                }
            }

            return idx;
        }
        //#endregion

        //#region tariff product

    }, {
        key: 'GetProduct',
        value: function GetProduct() {
            var _this7 = this;

            //Suche des TariffPoints Via inklusive Preis
            this.removePriceAndContractEnd();
            this.removeTraversedZones();

            this.viaInput.current.setState({ Data: null }, function () {
                var me = _this7;

                var from = {};
                var to = {};

                var resultFrom = _this7.TariffPointsModelFrom.TariffPoints;
                for (var i = 0; i < resultFrom.length; i++) {
                    if (resultFrom[i].DescriptionLong === (0, _jquery2.default)("#From").val()) {
                        from = resultFrom[i];
                        break;
                    }
                }

                var resultTo = _this7.TariffPointsModelTo.TariffPoints;
                for (var _i14 = 0; _i14 < resultTo.length; _i14++) {
                    if (resultTo[_i14].DescriptionLong === (0, _jquery2.default)("#To").val()) {
                        to = resultTo[_i14];
                        break;
                    }
                }

                if (to.Id !== undefined && from.Id !== undefined) {

                    _this7.viaInput.current.setState({ Loading: true }, function () {
                        _this7.Request.setErrorHandler(function () {
                            me.viaInput.current.setState({ Loading: false });
                        });
                        if (_this7.role === "1") {
                            _this7.ProductModel.GetTariffProducts(from, to, (0, _jquery2.default)("#TariffProducts").val().split(';')[0]);
                        } else if (_this7.role === "3") {
                            _this7.ProductModel.GetTariffProductsWithCustomerAbove(from, to, (0, _jquery2.default)("#TariffProducts").val().split(';')[0], null, _this7.state.CustomerAbove);
                        }
                    });
                }
            });
        }

        //#endregion

    }, {
        key: 'returnTariffProduct',
        value: function returnTariffProduct() {
            if (localStorage.getItem('FixedRoute') !== null && localStorage.getItem('FixedRoute') !== undefined && localStorage.getItem('FixedRoute') === "true") {
                if (document.getElementById("TariffProducts").selectedIndex > 0) {
                    //let via = this.TariffProductsModel.ProductList[document.getElementById("TariffProducts").selectedIndex -1];
                    var via = localStorage.getItem("TariffProduct") ? JSON.parse(localStorage.getItem("TariffProduct")) : this.TariffProductsModel.ProductList[document.getElementById("TariffProducts").selectedIndex - 1];
                    via.ContractEnd = this.state.ContractEnd ? this.state.ContractEnd : null;
                    var from = new _modelsLib.TariffPoint();
                    var curContractStart = _utilsLib.DateTimeHelper.StringToDate(this.state.ContractStart, false, localStorage.getItem('vas_language'));
                    from.ContractStart = moment([curContractStart.year(), curContractStart.month(), curContractStart.date()]).format("YYYY-MM-DDT00:00:00");
                    var to = new _modelsLib.TariffPoint();
                    var tariff = [via, from, to, this.state.CustomerAbove];
                    localStorage.setItem("Tariff", JSON.stringify(tariff));
                    return tariff;
                } else {
                    return [null, null, null, null];
                }
            } else {
                if (document.getElementById("Via").selectedIndex > 0) {
                    /*let product = $("#Product").val().split(';');
                    let productId = product[2];
                    let via = '';
                    for (let i = 0 ;  i< this.TariffProductsModel.ProductList.length; i++) {
                      if (this.TariffProductsModel.ProductList[i].IdTicket === productId){
                        via = this.TariffProductsModel.ProductList[i];
                        break;
                      }
                    } */

                    var _via = this.ProductModel.ProductList[document.getElementById("Via").selectedIndex - 1];
                    _via.ContractEnd = this.state.ContractEnd ? this.state.ContractEnd : null;
                    var _from = this.ProductModel.TariffPointFrom;
                    var _to = this.ProductModel.TariffPointTo;
                    var _tariff = [_via, _from, _to, this.state.CustomerAbove];
                    localStorage.setItem("Tariff", JSON.stringify(_tariff));
                    return _tariff;
                } else {
                    return [null, null, null, null];
                }
            }
        }
    }, {
        key: 'returnFields',
        value: function returnFields() {
            return [this.contractStartInput, this.clientInput, this.tariffProductInput, this.fromInput, this.toInput, this.viaInput, this.priceInput];
        }
    }, {
        key: 'returnFilled',
        value: function returnFilled() {
            return [this.allFilled, this.first];
        }

        //#region fields

    }, {
        key: 'SetFields',
        value: function SetFields() {
            var _this8 = this;

            var tariffProductsArray = localStorage.getItem('TariffProducts') !== null && localStorage.getItem('TariffProducts') !== undefined && localStorage.getItem('TariffProducts') !== 'undefined' ? JSON.parse(localStorage.getItem('TariffProducts')) : [];

            var fields = _react2.default.createElement('tr', null);

            fields = _react2.default.createElement(
                'tr',
                { id: "RelationFromToVia" },
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                        'table',
                        null,
                        _react2.default.createElement(
                            'tbody',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(_AutocompleteField2.default, {
                                            Autocomplete: false,
                                            AppURL: this.ApplicationUrl,
                                            TitleMessageFalseStreet: _Vas2.default.getText("Labels", "Error"),
                                            MessageFalseStreet: _Vas2.default.getText("Labels", "FalseProduct"),
                                            Modus: "TariffPoint",
                                            ref: this.fromInput,
                                            Id: "From",
                                            Float: 'left',
                                            IsRequired: true,
                                            Label: _Vas2.default.getText("Labels", "From"),
                                            OnChange: function OnChange() {
                                                _this8.Search("From");
                                            },
                                            Function: function Function() {
                                                _this8.TariffPointsModelFrom.SelectedTariffId = _this8.GetTariffPointOfArray(document.getElementById('From').value, _this8.TariffPointsModelFrom.TariffPoints);
                                                _this8.TariffProductsModel.TariffProducts = [];
                                                _this8.setVisible("From");
                                                if (!_this8.deleteRelationTo) {
                                                    _this8.GetProduct();
                                                }
                                            },
                                            PriceInfoText: _Vas2.default.getText("Labels", "ProductPrice") + " " + _Vas2.default.getText("Labels", "inEuro"),
                                            TimeOutTime: this.TimeOutTime,
                                            ClearFunction: function ClearFunction() {
                                                _this8.TariffPointsModelFrom.TariffPoints = [];

                                                _this8.TariffProductsModel.TariffProducts = [];

                                                _this8.setVisible("ContractStart");

                                                localStorage.removeItem('Tariff');
                                                _this8.Tariff = null;
                                                _this8.removeTraversedZones("From");
                                                _this8.setState({ SetDefault: false });
                                            },
                                            OnFocus: function OnFocus() {
                                                document.getElementById('From').select();
                                                localStorage.removeItem('Tariff');
                                                _this8.Tariff = null;
                                                //this.setState({SetDefault:false});
                                            },

                                            Tooltip: _Vas2.default.getText('Tooltips', "Start"),
                                            FindStrFromStreets: this.FindStrFromStreets,
                                            SubstringsAllowed: this.SubstringsAllowed })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(_AutocompleteField2.default, {
                                            Autocomplete: false,
                                            AppURL: this.ApplicationUrl,
                                            TitleMessageFalseStreet: _Vas2.default.getText("Labels", "Error"),
                                            MessageFalseStreet: _Vas2.default.getText("Labels", "FalseProduct"),
                                            Modus: "TariffPoint",
                                            ref: this.toInput,
                                            Id: "To",
                                            Float: 'left',
                                            IsRequired: true,
                                            Label: _Vas2.default.getText("Labels", "To"),
                                            OnChange: function OnChange() {
                                                _this8.Search("To");
                                            },
                                            Function: function Function() {
                                                _this8.TariffPointsModelTo.SelectedTariffId = _this8.GetTariffPointOfArray(document.getElementById('To').value, _this8.TariffPointsModelTo.TariffPoints);
                                                _this8.TariffProductsModel.TariffProducts = [];
                                                _this8.setVisible('To');
                                                _this8.GetProduct();
                                            },
                                            PriceInfoText: _Vas2.default.getText("Labels", "ProductPrice") + " " + _Vas2.default.getText("Labels", "inEuro"),
                                            TimeOutTime: this.TimeOutTime,
                                            ClearFunction: function ClearFunction() {
                                                _this8.TariffPointsModelTo.TariffPoints = [];

                                                _this8.TariffProductsModel.TariffProducts = [];

                                                if (_this8.deleteRelationTo == false) {
                                                    _this8.setVisible("From", "To");
                                                } else {
                                                    _this8.setVisible("From");
                                                }

                                                localStorage.removeItem('Tariff');
                                                _this8.Tariff = null;
                                                _this8.removeTraversedZones("To");
                                                _this8.setState({ SetDefault: false });
                                            },

                                            OnFocus: function OnFocus() {
                                                document.getElementById('To').select();
                                            },
                                            Tooltip: _Vas2.default.getText('Tooltips', "End"),
                                            FindStrFromStreets: this.FindStrFromStreets,
                                            SubstringsAllowed: this.SubstringsAllowed })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(_SelectField2.default, {
                                            AppURL: this.ApplicationUrl,
                                            ref: this.viaInput,
                                            Id: "Via",
                                            IsRequired: true,
                                            Label: _Vas2.default.getText("Labels", "Via"),
                                            OnChange: function OnChange() {
                                                _this8.setState({ Via: (0, _jquery2.default)("#Via").val() }, function () {
                                                    _this8.setPriceAndContractEnd();_this8.traversedZones();_this8.doAfterProducts((0, _jquery2.default)("#Via").val().split(';'));
                                                });
                                            },
                                            PriceInfoText: _Vas2.default.getText("Labels", "ProductPrice") + " " + _Vas2.default.getText("Labels", "inEuro"),
                                            Tooltip: _Vas2.default.getText('Tooltips', "Via")
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement('div', { id: "TraversedZonesArea" })
                                )
                            )
                        )
                    )
                )
            );

            if (this.Former === false && document.getElementById("From") !== null) {
                document.getElementById("From").focus();
                this.Former = true;
            }

            var e = document.getElementById("TariffProducts");
            var text = e == null ? "" : e.options[e.selectedIndex].text;

            if (document.getElementById('TariffProducts') !== undefined && document.getElementById('TariffProducts') !== null && document.getElementById('TariffProducts').selectedIndex > 0 && document.getElementById("ContractStart").selectedIndex > 0) {

                if (text == "Deutschlandticket Chipkarte") {
                    if (document.getElementById('Motiv1') !== undefined && document.getElementById('Motiv1') !== null && document.getElementById('Motiv2') !== undefined && document.getElementById('Motiv2') !== null && document.getElementById('Motiv3') !== undefined && document.getElementById('Motiv3') !== null && (document.getElementById('Motiv1').checked || document.getElementById('Motiv2').checked || document.getElementById('Motiv3').checked)) {
                        if (document.getElementById('Motiv1').checked) {
                            text = "Deutschlandticket (Motiv1)";
                        } else if (document.getElementById('Motiv2').checked) {
                            text = "Deutschlandticket (Motiv2)";
                        } else if (document.getElementById('Motiv3').checked) {
                            text = "Deutschlandticket (Motiv3)";
                        }

                        var tariffProductsArr = document.getElementById("TariffProducts").options[document.getElementById("TariffProducts").selectedIndex].value.split(';');
                        if (tariffProductsArr[2] === 'true') {

                            var fixedRoutes = [];
                            var fixedRoute = '';
                            var from = '';
                            var to = '';
                            var buttonText = '';

                            var idx = 0;

                            var _loop = function _loop(i) {
                                if (tariffProductsArray[i].FixedRoute === true && tariffProductsArray[i].TicketName === text) {

                                    from = tariffProductsArray[i].TzFromText === "" ? tariffProductsArray[i].IdendTzFrom : tariffProductsArray[i].TzFromText;
                                    to = tariffProductsArray[i].TzToText === "" ? tariffProductsArray[i].IdendTzTo : tariffProductsArray[i].TzToText;
                                    buttonText = _Vas2.default.getText("Labels", "Scope") + tariffProductsArray[i].PriceLevel;
                                    //buttonText = Vas.getText("Labels","From") +  ": " + from+ ' - ' + Vas.getText("Labels","To") + ": " + to;
                                    fixedRoute = _react2.default.createElement(
                                        'td',
                                        { style: { paddingTop: '10px', float: 'left', width: '400px' } },
                                        _react2.default.createElement(_ExtendedButton2.default, {
                                            Id: "i-" + i,
                                            Usable: true,
                                            Text: buttonText,
                                            Ref: _this8.fromToViaInput,
                                            OnClick: function OnClick() {
                                                var buttons = document.getElementsByClassName("selectedButton");
                                                for (var _i15 = 0; _i15 < buttons.length; _i15++) {
                                                    buttons[_i15].classList.remove('selectedButton');
                                                }
                                                document.getElementById("i-" + i).classList.add('selectedButton');
                                                _this8.setPriceAndContractEndFixedRoute("i-" + i);
                                            } })
                                    );
                                    idx = i;
                                    fixedRoutes.push(fixedRoute);

                                    //break;
                                }
                            };

                            for (var i = 0; i < tariffProductsArray.length; i++) {
                                _loop(i);
                            }

                            //fixedRoutesMapped = Object.keys(fixedRoutes).map(function(i){return fixedRoutes[i];});
                            if (fixedRoutes.length === 1) {
                                fields = _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { style: { paddingTop: '10px', float: 'left', width: '400px' } },
                                        _Vas2.default.getText("Labels", "Scope"),
                                        ' ',
                                        tariffProductsArray[idx].PriceLevel
                                    )
                                );
                                this.setPriceAndContractEndFixedRoute("i-" + idx);
                            } else {
                                fields = _react2.default.createElement(
                                    'tr',
                                    null,
                                    fixedRoutes
                                );
                            }

                            localStorage.setItem('FixedRoute', true);
                        } else {
                            localStorage.removeItem('FixedRoute');
                        }
                    }
                } else {
                    var _tariffProductsArr2 = document.getElementById("TariffProducts").options[document.getElementById("TariffProducts").selectedIndex].value.split(';');
                    if (_tariffProductsArr2[2] === 'true') {

                        var _fixedRoutes = [];
                        var _fixedRoute = '';
                        var _from2 = '';
                        var _to2 = '';
                        var _buttonText = '';

                        var _idx3 = 0;

                        var _loop2 = function _loop2(i) {
                            if (tariffProductsArray[i].FixedRoute === true && tariffProductsArray[i].TicketName === document.getElementById("TariffProducts").options[document.getElementById("TariffProducts").selectedIndex].text) {

                                _from2 = tariffProductsArray[i].TzFromText === "" ? tariffProductsArray[i].IdendTzFrom : tariffProductsArray[i].TzFromText;
                                _to2 = tariffProductsArray[i].TzToText === "" ? tariffProductsArray[i].IdendTzTo : tariffProductsArray[i].TzToText;
                                _buttonText = _Vas2.default.getText("Labels", "Scope") + tariffProductsArray[i].PriceLevel;
                                //buttonText = Vas.getText("Labels","From") +  ": " + from+ ' - ' + Vas.getText("Labels","To") + ": " + to;
                                _fixedRoute = _react2.default.createElement(
                                    'td',
                                    { style: { paddingTop: '10px', float: 'left', width: '400px' } },
                                    _react2.default.createElement(_ExtendedButton2.default, {
                                        Id: "i-" + i,
                                        Usable: true,
                                        Text: _buttonText,
                                        Ref: _this8.fromToViaInput,
                                        OnClick: function OnClick() {
                                            var buttons = document.getElementsByClassName("selectedButton");
                                            for (var _i16 = 0; _i16 < buttons.length; _i16++) {
                                                buttons[_i16].classList.remove('selectedButton');
                                            }
                                            document.getElementById("i-" + i).classList.add('selectedButton');
                                            _this8.setPriceAndContractEndFixedRoute("i-" + i);
                                        } })
                                );
                                _idx3 = i;
                                _fixedRoutes.push(_fixedRoute);

                                //break;
                            }
                        };

                        for (var i = 0; i < tariffProductsArray.length; i++) {
                            _loop2(i);
                        }

                        //fixedRoutesMapped = Object.keys(fixedRoutes).map(function(i){return fixedRoutes[i];});
                        if (_fixedRoutes.length === 1) {
                            fields = _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    { style: { paddingTop: '10px', float: 'left', width: '400px' } },
                                    _Vas2.default.getText("Labels", "Scope"),
                                    ' ',
                                    tariffProductsArray[_idx3].PriceLevel
                                )
                            );
                            this.setPriceAndContractEndFixedRoute("i-" + _idx3);
                        } else {
                            fields = _react2.default.createElement(
                                'tr',
                                null,
                                _fixedRoutes
                            );
                        }

                        localStorage.setItem('FixedRoute', true);
                    } else {
                        localStorage.removeItem('FixedRoute');
                    }
                }
            }

            return fields;
        }
    }, {
        key: 'SetHint',
        value: function SetHint() {

            var hint = '';
            var hintArr = [];

            //Wenn SeniorenAbo, dann Abfrage der Multimediatexte und hintsMapped hier füllen
            this.GetMultimediaTexts();

            var hints = _react2.default.createElement('tr', null);
            if (localStorage.getItem('MultimediaTexts') !== null) {

                var multimediatextsArray = JSON.parse(localStorage.getItem('MultimediaTexts'));

                for (var i = 0; i < multimediatextsArray.length; i++) {
                    hint = _react2.default.createElement(
                        'div',
                        null,
                        multimediatextsArray[i].Display
                    );

                    hintArr.push(hint);
                }

                var hintsMapped = Object.keys(hintArr).map(function (i) {
                    return hintArr[i];
                });

                hints = _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                        'td',
                        { style: { paddingTop: '10px', float: 'left', width: '400px' } },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'b',
                                null,
                                _Vas2.default.getText("Titles", "Note"),
                                ':'
                            )
                        ),
                        hintsMapped
                    )
                );
            }

            this.hint = hints;
        }
    }, {
        key: 'GetMultimediaTexts',
        value: function GetMultimediaTexts() {

            localStorage.removeItem('MultimediaTexts');

            //Hier das gewählte Produkt ermitteln
            var tariffProductsArray = localStorage.getItem('TariffProducts') !== null && localStorage.getItem('TariffProducts') !== undefined ? JSON.parse(localStorage.getItem('TariffProducts')) : [];

            if (tariffProductsArray !== null) {

                for (var i = 0; i < tariffProductsArray.length; i++) {

                    if (tariffProductsArray[i].TicketName === 'Senioren-Abo Netz 1. Kl. pers.') {

                        this.MultimediaTextModel.GetMultimediaTextFromTariffProduct(tariffProductsArray[i]);
                        break;
                    }
                }
            }
        }
        //#endregion

    }, {
        key: 'changeProduct',
        value: function changeProduct(value) {
            var _this9 = this;

            var me = this;

            var product = '';
            var ticketId = null;

            product = value;
            ticketId = product.split(";")[0] ? product.split(";")[0] : null;

            this.setState({ TariffProducts: value, SetDefault: true, ContractEnd: null }, function () {
                _this9.contractStartInput.current.setState({ Data: [] }, function () {
                    if (_this9.ContractId !== "00000") {
                        _this9.ContractStartParamsModel.GetContractStartParamsByContractId(_this9.ContractId, ticketId);
                    } else {
                        _this9.ContractStartParamsModel.GetContractStartParamsByTicketId(ticketId);
                    }
                });

                _this9.MultimediaTextProductModel.GetMultimediaTextFromTicketId(ticketId);

                _this9.Tariff = null;
                _this9.setVisible("Product");
                if (localStorage.getItem('FixedRoute') !== null && localStorage.getItem('FixedRoute') !== undefined && localStorage.getItem('FixedRoute') === "true") {
                    _this9.doAfterProducts((0, _jquery2.default)("#TariffProducts").val().split(";"));
                }

                if (_this9.ConfigDefaults.ShowHintsTariffing === true) {
                    var flagSchulerTicket = product.split(";")[7] !== null && product.split(";")[7] !== undefined ? product.split(";")[7] : false;
                    var fromHint = "";
                    var toHint = "";
                    if (flagSchulerTicket === "true") {
                        fromHint = _Vas2.default.getText("Labels", "HintSchuelerTicketFrom");
                        toHint = _Vas2.default.getText("Labels", "HintSchuelerTicketTo");
                    } else {
                        fromHint = _Vas2.default.getText("Labels", "HintSonstTicketFrom");
                        toHint = _Vas2.default.getText("Labels", "HintSonstTicketTo");
                    }

                    if (_this9.fromInput && _this9.toInput) {
                        console.log(_this9.fromInput);
                        console.log(_this9.fromInput.current);
                        if (_this9.fromInput.current && _this9.toInput.current) {
                            _this9.fromInput.current.setState({ HintAutoComplete: fromHint });
                            _this9.toInput.current.setState({ HintAutoComplete: toHint });
                        }
                    }
                }
            });

            this.doAfterTickets(ticketId);
        }
    }, {
        key: 'changeProductFromTermsOfUsage',
        value: function changeProductFromTermsOfUsage(value) {
            var _this10 = this;

            var product = '';
            var ticketId = null;

            product = value;
            ticketId = product.split(";")[0] ? product.split(";")[0] : null;

            this.setState({ TariffProducts: value, SetDefault: true, ContractEnd: null }, function () {

                _this10.Tariff = null;
                _this10.setVisible("Product");
                if (localStorage.getItem('FixedRoute') !== null && localStorage.getItem('FixedRoute') !== undefined && localStorage.getItem('FixedRoute') === "true") {
                    _this10.doAfterProducts((0, _jquery2.default)("#TariffProducts").val().split(";"));
                }

                if (_this10.ConfigDefaults.ShowHintsTariffing === true) {
                    var flagSchulerTicket = product.split(";")[7] !== null && product.split(";")[7] !== undefined ? product.split(";")[7] : false;
                    var fromHint = "";
                    var toHint = "";
                    if (flagSchulerTicket === "true") {
                        fromHint = _Vas2.default.getText("Labels", "HintSchuelerTicketFrom");
                        toHint = _Vas2.default.getText("Labels", "HintSchuelerTicketTo");
                    } else {
                        fromHint = _Vas2.default.getText("Labels", "HintSonstTicketFrom");
                        toHint = _Vas2.default.getText("Labels", "HintSonstTicketTo");
                    }

                    if (_this10.fromInput && _this10.toInput) {
                        console.log(_this10.fromInput);
                        console.log(_this10.fromInput.current);
                        if (_this10.fromInput.current && _this10.toInput.current) {
                            _this10.fromInput.current.setState({ HintAutoComplete: fromHint });
                            _this10.toInput.current.setState({ HintAutoComplete: toHint });
                        }
                    }
                }
            });

            this.doAfterTickets(ticketId);
        }
    }, {
        key: 'FontSizeClick',
        value: function FontSizeClick() {
            var schriftgröße = localStorage.getItem('Schriftgröße');

            //Schriftgröße bei Klick in 2er Schritten erhöhen

            if (schriftgröße != null) {
                switch (schriftgröße) {
                    case "0":
                        (0, _jquery2.default)('#From, #To').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                        (0, _jquery2.default)('#TariffProducts').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                        (0, _jquery2.default)('#btoChooseDocument').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                        (0, _jquery2.default)('#Price').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                        (0, _jquery2.default)('#i-10, #i-11, #i-12, #i-13, #i-14, #i-15, #i-16, #i-17, #i-18, #i-19, #i-20, #i-21, #i-22, #i-23').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                        break;
                    case "1":
                        (0, _jquery2.default)('#From, #To').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                        (0, _jquery2.default)('#TariffProducts').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                        (0, _jquery2.default)('#btoChooseDocument').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                        (0, _jquery2.default)('#Price').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                        (0, _jquery2.default)('#i-10, #i-11, #i-12, #i-13, #i-14, #i-15, #i-16, #i-17, #i-18, #i-19, #i-20, #i-21, #i-22, #i-23').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                        break;
                    case "2":
                        (0, _jquery2.default)('#From, #To').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                        (0, _jquery2.default)('#TariffProducts').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                        (0, _jquery2.default)('#btoChooseDocument').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                        (0, _jquery2.default)('#Price').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                        (0, _jquery2.default)('#i-10, #i-11, #i-12, #i-13, #i-14, #i-15, #i-16, #i-17, #i-18, #i-19, #i-20, #i-21, #i-22, #i-23').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                        break;
                    case "3":
                        (0, _jquery2.default)('#From, #To').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                        (0, _jquery2.default)('#TariffProducts').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                        (0, _jquery2.default)('#btoChooseDocument').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                        (0, _jquery2.default)('#Price').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                        (0, _jquery2.default)('#i-10, #i-11, #i-12, #i-13, #i-14, #i-15, #i-16, #i-17, #i-18, #i-19, #i-20, #i-21, #i-22, #i-23').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                        break;
                    case "4":
                        (0, _jquery2.default)('#From, #To').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                        (0, _jquery2.default)('#TariffProducts').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                        (0, _jquery2.default)('#btoChooseDocument').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                        (0, _jquery2.default)('#Price').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                        (0, _jquery2.default)('#i-10, #i-11, #i-12, #i-13, #i-14, #i-15, #i-16, #i-17, #i-18, #i-19, #i-20, #i-21, #i-22, #i-23').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                        break;
                    case "5":
                        (0, _jquery2.default)('#From, #To').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                        (0, _jquery2.default)('#TariffProducts').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                        (0, _jquery2.default)('#btoChooseDocument').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                        (0, _jquery2.default)('#Price').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                        (0, _jquery2.default)('#i-10, #i-11, #i-12, #i-13, #i-14, #i-15, #i-16, #i-17, #i-18, #i-19, #i-20, #i-21, #i-22, #i-23').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                        break;
                }
            }
        }
    }, {
        key: 'LogoClick',
        value: function LogoClick() {
            var kontrastNumber = localStorage.getItem('Kontrast');

            //Schriftgröße bei Klick in 2er Schritten erhöhen

            if (kontrastNumber == "true") {

                (0, _jquery2.default)('#i-10, #i-11, #i-12, #i-13, #i-14, #i-15, #i-16, #i-17, #i-18, #i-19, #i-20, #i-21, #i-22, #i-23').attr('style', 'background-color: #1d5c87 !important;');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this11 = this;

            var aboCenterFalse = _react2.default.createElement('div', null);
            var aboCenterTrue = _react2.default.createElement('div', null);

            if (this.ShowClientsBox === true) {
                aboCenterTrue = _react2.default.createElement(_SelectField2.default, {
                    AppURL: this.ApplicationUrl,
                    me: this,
                    ref: this.clientInput,
                    Id: "AboCenter",
                    IsRequired: true,
                    Label: _Vas2.default.getText("Labels", "AboCenter"),
                    Tooltip: _Vas2.default.getText("Tooltips", "AboCenter"),
                    Data: this.AboCenterArray,
                    OnChange: function OnChange() {
                        _this11.setState({ AboCenter: (0, _jquery2.default)("#AboCenter").val() }, function () {
                            _this11.setVisible("AboCenter");_this11.GetTickets("AboCenter");
                        });
                    } });
            }

            var contractEndFalse = _react2.default.createElement('div', null);
            var contractEndTrueDate = _react2.default.createElement('div', null);
            var contractEndTrueText = _react2.default.createElement('div', null);

            var showDay = true;
            if (this.ConfigContractEnd.ShowDay !== true) {
                showDay = false;
            }
            if (this.ShowContractEnd === true) {
                if (this.ConfigContractEnd.ChangeContractEnd === true) {
                    contractEndTrueDate = _react2.default.createElement(_DateField2.default, {
                        AppURL: _Vas2.default.ApplicationUrl,
                        me: this,
                        Editable: true,
                        ref: this.contractEndInput,
                        IsRequired: true,
                        Id: "ContractEnd",
                        Label: this.ContractEndText,
                        OnBlur: function OnBlur() {
                            if (showDay === true) {
                                var cur = _utilsLib.DateTimeHelper.StringToDate((0, _jquery2.default)("#ContractEnd").val(), false, localStorage.getItem('vas_language'));
                                var curMoment = moment([cur.year(), cur.month(), cur.date()]);
                                if (curMoment.isSameOrBefore(moment(), 'day')) {
                                    _this11.setState({ ContractEnd: null });
                                } else {
                                    _this11.setState({ ContractEnd: curMoment.format("YYYY-MM-DDT00:00:00") });
                                }
                            } else {

                                if ((0, _jquery2.default)("#ContractEnd").val() != '') {
                                    var val = '01.' + (0, _jquery2.default)("#ContractEnd").val();
                                    var _cur2 = _utilsLib.DateTimeHelper.StringToDate(val, false, localStorage.getItem('vas_language'));
                                    _cur2.date(_utilsLib.DateTimeHelper.GetLastDayOfMonth(_cur2.month(), _cur2.year()));
                                    var _curMoment2 = moment([_cur2.year(), _cur2.month(), _cur2.date()]);
                                    if (_curMoment2.isSameOrBefore(moment(), 'day')) {
                                        _this11.setState({ ContractEnd: null });
                                    } else {
                                        _this11.setState({ ContractEnd: _curMoment2.format("YYYY-MM-DDT00:00:00") });
                                    }
                                } else {
                                    _this11.setState({ ContractEnd: null });
                                }
                            }
                        },
                        Language: localStorage.getItem("vas_language"),
                        Tooltip: _Vas2.default.getText('Tooltips', "ContractEnd"),
                        ShowDay: showDay
                    });
                } else {
                    contractEndTrueText = _react2.default.createElement(_Textfield2.default, {
                        AppURL: this.ApplicationUrl,
                        Editable: false,
                        ref: this.contractEndInput,
                        Id: "ContractEnd",
                        Label: this.ContractEndText
                    });
                }
            }

            var fields = this.SetFields();

            if (localStorage.getItem('MultimediaTextProduct') !== null && localStorage.getItem('MultimediaTextProduct') !== undefined) {
                var cur = JSON.parse(localStorage.getItem('MultimediaTextProduct'));
                var table = document.getElementById("termsOfUsage");

                if (cur.length == 0) {
                    if (table !== null && table !== undefined) {
                        for (var i = table.rows.length - 1; i >= 0; i--) {
                            table.deleteRow(i);
                        }
                    }
                    var productKey = (0, _jquery2.default)("#TariffProducts").val();
                    var productList = JSON.parse(localStorage.getItem('returnProducts'));
                    var result = productList.find(function (obj) {
                        return obj.Key === productKey;
                    });

                    if (result != null) {
                        if (document.getElementById(result.Display) != null) {
                            document.getElementById(result.Display).style.display = "block";
                        }

                        if (result.Display == "Deutschlandticket Chipkarte") {
                            if (document.getElementById("ChooseDeutschlandTicket") != null) {
                                document.getElementById("ChooseDeutschlandTicket").style.display = "block";
                            }
                        } else {
                            if (document.getElementById("ChooseDeutschlandTicket") != null) {
                                document.getElementById("ChooseDeutschlandTicket").style.display = "none";
                            }
                        }
                    }
                }

                if (table !== null && table !== undefined) {
                    for (var _i17 = table.rows.length - 1; _i17 >= 0; _i17--) {
                        table.deleteRow(_i17);
                    }
                    for (var _i18 = 0; _i18 < cur.length; _i18++) {

                        var text = cur[_i18].value;
                        var textArr = text.split(" - ");
                        var connector = "";

                        var list = '<ul style="list-style-type:unset;list-style-position:outside;margin-top:0px;margin-botton:0px;" ';
                        for (var j = 0; j < textArr.length; j++) {
                            if (_i18 === 0 && j === 0) {
                                //let rowTop = table.insertRow();
                                //let cellTop = rowTop.insertCell();
                                //cellTop.innerHTML = '<ol style="list-style-type:none;list-style-position:outside;margin-top:0px;margin-botton:0px;margin-left:-16px"><li>' +Vas.getText("Labels","TermsOfUsage") + ':</li></ol>';
                                list += 'data-header="' + _Vas2.default.getText("Labels", "TermsOfUsage") + ':" >';
                            }
                            //let row = table.insertRow();
                            //let cell = row.insertCell();

                            if (j === 0) {
                                if (textArr[j].charAt(0) === "-") {
                                    connector = "- ";
                                    list += '<li>' + textArr[j].split("-")[1] + '</li>';
                                    //cell.innerHTML = '<ul style="list-style-type:unset;list-style-position:outside;margin-top:0px;margin-botton:0px;"><li>' +textArr[j].split("-")[1] +'</li></ul>';
                                } else {
                                    list += '<li>' + textArr[j] + '</li>';
                                    //cell.innerHTML = '<ul style="list-style-type:unset;list-style-position:outside;margin-top:0px;margin-botton:0px;"><li>' +textArr[j] +'</li></ul>';
                                }
                                //cell.innerHTML = textArr[j];
                            } else {
                                // cell.innerHTML = connector + textArr[j];
                                list += '<li>' + textArr[j] + '</li>';
                                //cell.innerHTML = '<ul style="list-style-type:unset;list-style-position:outside;margin-top:0px;margin-botton:0px;"><li>' +textArr[j] +'</li></ul>';
                            }
                        }
                        list += '</ul>';
                        var row = table.insertRow();
                        var cell = row.insertCell();
                        cell.innerHTML = list;
                    }
                }
            }

            var customerAbove = _react2.default.createElement('div', null);
            if (this.role === "3") {
                customerAbove = _react2.default.createElement(_SelectField2.default, {
                    AppURL: this.ApplicationUrl,
                    me: this,
                    ref: this.customerAboveInput,
                    Id: "CustomerAbove",
                    IsRequired: true,
                    Label: _Vas2.default.getText("Labels", "Company"),
                    Tooltip: _Vas2.default.getText("Tooltips", "Company"),
                    OnChange: function OnChange() {
                        _this11.setState({ CustomerAbove: (0, _jquery2.default)("#CustomerAbove").val() }, function () {
                            _this11.setVisible("CustomerAbove");_this11.ClientModel.GetClients();
                        });
                    } });
            }
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'table',
                        null,
                        _react2.default.createElement(
                            'tbody',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'td',
                                    { style: { width: '400px', verticalAlign: 'top' } },
                                    _react2.default.createElement(
                                        'table',
                                        null,
                                        _react2.default.createElement(
                                            'tbody',
                                            null,
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: "divLeft" },
                                                        customerAbove
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: "divLeft" },
                                                        _react2.default.createElement(_SelectField2.default, {
                                                            AppURL: this.ApplicationUrl,
                                                            me: this,
                                                            ref: this.tariffProductInput,
                                                            Id: "TariffProducts",
                                                            IsRequired: true,
                                                            Label: _Vas2.default.getText("Labels", "ProductSelection"),
                                                            Tooltip: _Vas2.default.getText("Tooltips", "ProductSelection"),
                                                            Data: this.TariffProducts,
                                                            OnChange: function OnChange() {
                                                                _this11.changeProduct((0, _jquery2.default)("#TariffProducts").val());
                                                            },
                                                            Width: 350
                                                            //ShowDouble={false}
                                                        })
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: "divLeft" },
                                                        _react2.default.createElement(_SelectField2.default, {
                                                            AppURL: this.ApplicationUrl,
                                                            ref: this.contractStartInput,
                                                            Id: "ContractStart",
                                                            IsRequired: true,
                                                            Label: _Vas2.default.getText("Labels", "ContractStart"),
                                                            OnChange: function OnChange() {
                                                                _this11.setState({ ContractStart: (0, _jquery2.default)("#ContractStart").val(), SetDefault: true }, function () {
                                                                    var e = document.getElementById("TariffProducts");
                                                                    var text = e.options[e.selectedIndex].text;
                                                                    if (text == "Deutschlandticket Chipkarte" && !document.getElementById("Motiv1").checked && !document.getElementById("Motiv2").checked && !document.getElementById("Motiv3").checked) {
                                                                        document.getElementById("ContractStart").selectedIndex = 0;
                                                                        _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                                                                            Message: _Vas2.default.getText("Labels", "GermanTicketNoMitivSelected"),
                                                                            Title: _Vas2.default.getText("Titles", "Note")
                                                                        }), document.getElementById('messageContainer'));
                                                                    } else {
                                                                        localStorage.removeItem('Tariff');
                                                                        _this11.Tariff = null;
                                                                        _this11.removeTraversedZones("To");

                                                                        _this11.setVisible("ContractStart");

                                                                        _this11.setDefault("From");
                                                                    }

                                                                    _this11.LogoClick();
                                                                    _this11.FontSizeClick();
                                                                });
                                                            },
                                                            Tooltip: _Vas2.default.getText("Tooltips", "ContractStart") })
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'td',
                                                    { colSpan: 2 },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { id: 'HintContractStart', className: "HintLabel" },
                                                        this.Text
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    aboCenterFalse,
                                                    aboCenterTrue
                                                ),
                                                _react2.default.createElement('td', null)
                                            ),
                                            _react2.default.createElement('tr', null),
                                            this.hint,
                                            fields,
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'td',
                                                    { id: "PriceInformation", colSpan: 2 },
                                                    _react2.default.createElement(_Textfield2.default, {
                                                        AppURL: this.ApplicationUrl,
                                                        ref: this.priceInput,
                                                        Editable: false,
                                                        Id: "Price",
                                                        Label: _Vas2.default.getText("Labels", "ProductPrice") + " " + _Vas2.default.getText("Labels", "inEuro")
                                                    })
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'tr',
                                                null,
                                                _react2.default.createElement(
                                                    'td',
                                                    { colSpan: 2 },
                                                    contractEndTrueText,
                                                    contractEndTrueDate,
                                                    contractEndFalse
                                                )
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'td',
                                    { style: { verticalAlign: 'top' } },
                                    _react2.default.createElement(
                                        'div',
                                        { id: "TermsOfUsage", className: "termsOfUsage" },
                                        _react2.default.createElement(
                                            'table',
                                            { id: 'termsOfUsage' },
                                            _react2.default.createElement('tbody', null)
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return TariffingProductsToPoints;
}(_react.Component);

exports.default = TariffingProductsToPoints;